import React, { useState, useEffect, useMemo, useRef } from 'react';
import IscilikHesap from '../Iscilik/IscilikHesap';
import AracHasarHesap from '../AracHasar/AracHasarHesap';
import { DAVA_TURU, DAVA_TURU_LABELS, getSortedDavaTuruEntries, CASE_FILE_STATUS, CASE_FILE_STATUS_LABELS, DOCUMENT_TYPE, DOCUMENT_TYPE_LABELS, ICRA_KONUSU_OPTIONS } from '../../utils/constants';
import { referansAPI, vekaletAPI, userAPI, masrafAPI, documentAPI, caseFileAPI, noteAPI, vekaletnameAPI } from '../../api/api';
import { useAuth } from '../../context/AuthContext';
import { formatDateForInput, formatDateForDateInput, toISODateOrNull } from '../../utils/dateUtils';
import { getGuncelAvansOrani } from '../../utils/faiz';
import MasrafForm from '../Masraflar/MasrafForm';
import NoteForm from '../Notes/NoteForm';
import { ARABULUCULUK_SONUC, SONUC_SIRASI } from './ArabuluculukBolumu';
import './CaseFileForm.css';
import { onayla } from '../../utils/onayla';

const EMPTY_CASE_FILES = [];

const CaseFileForm = ({ caseFile, onSubmit, onCancel, onDelete, onArchiveRequest, loading, ozelMode = false }) => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    FoyNo: '',
    Muvekkil: '',
    MuvekkilTC: '', // TC veya şirket ise Vergi No
    IsSirket: false,
    MuvekkilTelefon: '',
    MuvekkilAdres: '',
    SirketYetkilisiAdi: '',
    SirketYetkilisiTC: '',
    MuvekkilIBAN: '',
    MuvekkilPlaka: '',
    MuvekkilAracRolu: '', // 'Yolcu' | 'Yaya' | ''
    MuvekkilAracSigortaSirketi: '', // Müvekkil araç sigorta şirketi
    KarsiTarafSigortaSirketi: '',
    KarsiTarafPlaka: '',
    KarsiTaraf1: '',
    KarsiTaraf2: '',
    KarsiTarafSigortaSirketiVekili: '',
    KazaSehri: '',
    KazaTarihi: '',
    DosyaGelisTarihi: '',
    ZamanAsimiTarihi: '',
    TahkimBasvuruTarihi: '',
    DurusmaTarihi: '',
    SigortaBasvuruTarihi: '',
    DavaAcilisTarihi: '',
    RaporTarihi: '',
    FizikiDosyaMevcut: false,
    DavaTuru: DAVA_TURU.None,
    DavaTuruDiger: '',
    ReferansId: null,
    SozlesmeOrani: '',
    SozlesmeOraniKdvDahil: false,
    TahkimBasvuruNo: '',
    ItirazBasvuruNo: '',
    MahkemaBilgisi: '',
    MahkemeEsas: '',
    SavcilikCezaDosyaNo: '',
    IcraDosyaNo: '',
    GelenOdemeDurumu: '',
    GidenOdemeDurumu: '',
    IbraAsamasi: '',
    SMM: '',
    SulhDurumu: '',
    Status: CASE_FILE_STATUS.None,
    CaseFileId: null,
    SorumluId: null,
    VekaletTuru: '', // 'Süreli' veya 'Süresiz'
    VekaletBitisTarihi: '',
    VekaletinAsliVar: false,
    // İcra Takip / İcra Dava alanları
    TakipAcilisMiktari: '',
    TakipTarihi: '',
    IcraFaizTuru: 'Yasal',
    IcraFaizOrani: '',
    IcraFaizBaslangicTarihi: '',
    IcraTahsilAsamasi: 'once',
    IcraVekaletUcretiManuel: '',
    IcraKonusu: '',
    IcraIlamsiz: true,
    BorcluSayisi: 1,
    KesinlesmeTarihi: '',
    // Boşanma / Mal Rejimi
    MuvekkilDavaci: false,
    MuvekkilDavali: false,
    EsAdSoyad: '',
    EsTC: '',
    EsCalisiyor: false,
    EvlilikTarihi: '',
    AyrilikTarihi: '', // Boşanma Tarihi
    BosanmaSebebi: '',
    CocukSayisi: '',
    VelayetTalebi: false,
    TalepNafaka: false,
    TalepTedbirNafaka: false,
    TalepIstirakNafaka: false,
    TalepYoksullukNafaka: false,
    TalepMaddiTazminat: false,
    TalepManeviTazminat: false,
    OdemeBilgileriGoster: false,
    DetayAlanGoster: {},
    // Ceza / Soruşturma
    MuvekkilSanik: false,
    MuvekkilMusteki: false,
    MuvekkilSupheli: false,
    SucTuru: '',
    SucTarihi: '',
    SucYeri: '',
    TckMaddesi: '',
    TedbirTutuklu: false,
    TedbirAdliKontrol: false,
    TedbirYakalamaKarari: false,
    KovusturmayaYerOlmadigiKarari: false,
    IddianameTarihi: '',
    TarafSayisi: '',
    // İşçilik Alacakları
    IsverenFirma: '',
    IsverenTcvkn: '',
    IsverenYetkilisi: '',
    IsverenAdresi: '',
    SgkSicilNo: '',
    IseGirisTarihi: '',
    IstenCikisTarihi: '',
    CikisNedeni: '',
    SonUcret: '',
    TalepKidem: false,
    TalepIhbar: false,
    TalepFazlaMesai: false,
    TalepUbgt: false,
    TalepHaftaTatili: false,
    TalepYillikIzin: false,
    TalepAgi: false,
    TalepMaasAlacagi: false,
    ArabuluculukTarihi: '',
    SonTutanakTarihi: '',
    ArabuluculukSonucu: '',
    ArabuluculukDosyaNo: '',
    IscilikDavaTarihi: '',
    BilirkisiTarihi: '',
    IslahTarihi: '',
  });

  const [cocuklar, setCocuklar] = useState([]); // [{ adSoyad, dogumTarihi }]
  const [taraflar, setTaraflar] = useState([]); // [{ adSoyad, tc, rol }]
  // Dava türü işçilik alacakları ise formun içinde açılan hesap paneli
  const [iscilikHesapAcik, setIscilikHesapAcik] = useState(false);
  const [aracHesapAcik, setAracHesapAcik] = useState(false);
  const emptyBorclu = () => ({ adSoyad: '', tc: '', adres: '', isSirket: false });

  /**
   * Seçilen vekaletnameyi okuyup müvekkil alanlarını doldurur.
   *
   * Yalnızca BOŞ alanlar doldurulur — elle yazdığınız bilgiyi ezmez.
   * Okuma her zaman doğru olmadığı için okunan her şey ayrıca listelenir
   * ve kontrol edilmesi beklenir.
   */
  const vekaletnameyiOku = async () => {
    if (!vekaletDosyasi) return;
    setVekaletOkunuyor(true);
    setVekaletSonuc(null);
    try {
      const s = await vekaletnameAPI.okuYuklenen(vekaletDosyasi);
      if (!(s.okundu ?? s.Okundu)) {
        setVekaletSonuc({ hata: s.hata ?? s.Hata ?? 'Vekaletname okunamadı.' });
        return;
      }

      const b = s.bilgi ?? s.Bilgi ?? {};
      const tcGecerli = !!(s.tcGecerli ?? s.TcGecerli);
      const dolan = [];

      setFormData((prev) => {
        const yeni = { ...prev };
        const koy = (alan, deger, etiket) => {
          if (!deger) return;
          if (String(yeni[alan] ?? '').trim()) return;   // dolu olanı ezme
          yeni[alan] = String(deger).trim();
          dolan.push(etiket);
        };

        koy('Muvekkil', b.adSoyad ?? b.AdSoyad, 'ad soyad');
        if (tcGecerli) koy('MuvekkilTC', b.tc ?? b.Tc, 'TC');
        koy('MuvekkilAdres', b.adres ?? b.Adres, 'adres');
        koy('MuvekkilTelefon', b.telefon ?? b.Telefon, 'telefon');

        // Şirket işaretliyse okunan kişi şirketin yetkilisidir.
        if (yeni.IsSirket) {
          koy('SirketYetkilisiAdi', b.adSoyad ?? b.AdSoyad, 'şirket yetkilisi');
          if (tcGecerli) koy('SirketYetkilisiTC', b.tc ?? b.Tc, 'yetkili TC');
        }

        // Vekalet türü ve süresi de vekaletnamede yazıyor.
        const vTur = b.vekaletTuru ?? b.VekaletTuru;
        koy('VekaletTuru', vTur, 'vekalet türü');
        if (vTur === 'Süreli') {
          const bit = b.bitisTarihi ?? b.BitisTarihi;   // gg.aa.yyyy
          if (bit && !String(yeni.VekaletBitisTarihi ?? '').trim()) {
            const p = String(bit).split('.');
            if (p.length === 3) {
              // Tarih alanı yyyy-aa-gg bekliyor.
              yeni.VekaletBitisTarihi = p[2] + '-' + p[1].padStart(2, '0') + '-' + p[0].padStart(2, '0');
              dolan.push('vekalet bitiş tarihi');
            }
          }
        }

        return yeni;
      });

      // Süreli seçildiyse bitiş tarihi alanı görünür olmalı.
      if ((b.vekaletTuru ?? b.VekaletTuru) === 'Süreli') setShowVekaletBitisTarihi(true);

      setVekaletSonuc({
        dolan,
        tcGecerli,
        okunan: {
          adSoyad: b.adSoyad ?? b.AdSoyad,
          tc: b.tc ?? b.Tc,
          adres: b.adres ?? b.Adres,
          telefon: b.telefon ?? b.Telefon,
          dogumTarihi: b.dogumTarihi ?? b.DogumTarihi,
          babaAdi: b.babaAdi ?? b.BabaAdi,
          anaAdi: b.anaAdi ?? b.AnaAdi,
          noterAdi: b.noterAdi ?? b.NoterAdi,
          duzenlemeTarihi: b.duzenlemeTarihi ?? b.DuzenlemeTarihi,
          vekaletTuru: b.vekaletTuru ?? b.VekaletTuru,
          bitisTarihi: b.bitisTarihi ?? b.BitisTarihi,
        },
      });
      setHasChanges(true);
    } catch (e) {
      setVekaletSonuc({ hata: e.response?.data?.message || e.message || 'Okunamadı.' });
    } finally {
      setVekaletOkunuyor(false);
    }
  };

  /**
   * Telefonu 05XXXXXXXXX biçimine getirir; uymuyorsa olduğu gibi bırakır.
   * Sunucuda da aynı kural var (VekaletnameServisi.TelefonBicimi).
   */
  // --- Vekaletnameden doldurma ---
  const [vekaletDosyasi, setVekaletDosyasi] = useState(null);
  const [vekaletOkunuyor, setVekaletOkunuyor] = useState(false);
  const [vekaletSonuc, setVekaletSonuc] = useState(null);

  /**
   * TC kimlik numarasının resmî doğrulama algoritması.
   * Son iki hane kontrol hanesidir; yanlış yazılmış numara buradan geçmez.
   * Şirket müvekkilde alan 10 haneli vergi numarası tutar, bu kural uygulanmaz.
   */
  const tcGecerliMi = (tc) => {
    const t = String(tc || '').trim();
    if (t.length !== 11 || !/^\d+$/.test(t) || t[0] === '0') return false;
    const d = t.split('').map(Number);
    const tek = d[0] + d[2] + d[4] + d[6] + d[8];
    const cift = d[1] + d[3] + d[5] + d[7];
    let o = ((tek * 7) - cift) % 10;
    if (o < 0) o += 10;
    if (o !== d[9]) return false;
    return d.slice(0, 10).reduce((a, b) => a + b, 0) % 10 === d[10];
  };

  const telefonBicimi = (ham) => {
    if (!ham) return ham;
    let r = String(ham).replace(/\D/g, '');
    if (r.startsWith('0090') && r.length === 14) r = '0' + r.slice(4);
    if (r.startsWith('90') && r.length === 12) r = '0' + r.slice(2);
    if (r.length === 10 && r[0] === '5') r = '0' + r;
    return (r.length === 11 && r.startsWith('05')) ? r : ham;
  };
  const [borclular, setBorclular] = useState([emptyBorclu()]);
  const CEZA_TARAF_ROLLERI = ['Müşteki', 'Sanık', 'Şüpheli', 'Davacı', 'Tanık'];
  const isSirket = !!formData.IsSirket;
  const [referanslar, setReferanslar] = useState([]);
  const [loadingReferanslar, setLoadingReferanslar] = useState(true);
  const [showOtherSigorta, setShowOtherSigorta] = useState(false);
  const [showOtherMuvekkilSigorta, setShowOtherMuvekkilSigorta] = useState(false);
  const [showVekaletBitisTarihi, setShowVekaletBitisTarihi] = useState(false);
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [masrafData, setMasrafData] = useState([]); // Çoklu masraf için array
  const [showMasrafForm, setShowMasrafForm] = useState(false);
  const [isMasrafSubmitting, setIsMasrafSubmitting] = useState(false);
  const [noteData, setNoteData] = useState([]); // Çoklu not için array
  const [showNoteForm, setShowNoteForm] = useState(false);
  const [isNoteSubmitting, setIsNoteSubmitting] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [fileDescriptions, setFileDescriptions] = useState({});
  const [uploading, setUploading] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);
  const [selectedDocumentType, setSelectedDocumentType] = useState(DOCUMENT_TYPE.Other);
  const [dragActive, setDragActive] = useState(false);
  const [icraTakipBilgisiEkle, setIcraTakipBilgisiEkle] = useState(false);
  const [allCaseFiles, setAllCaseFiles] = useState([]);
  const [loadingCaseFiles, setLoadingCaseFiles] = useState(!caseFile);
  const [selectedLinkedFiles, setSelectedLinkedFiles] = useState([]); // Seçilen bağlantılı dosya ID'leri
  const [initialLinkedFiles, setInitialLinkedFiles] = useState([]); // Başlangıçtaki bağlantılı dosya ID'leri (karşılaştırma için)
  const [linkedFilesSearchTerm, setLinkedFilesSearchTerm] = useState(''); // Bağlantılı dosyalar arama terimi
  /** Bağlantılı dosyadan alan aktarıldığında kısa bilgi satırı. */
  const [aktarimNotu, setAktarimNotu] = useState('');
  const foyTouchedRef = useRef(false);

  // Bağlantılı dosya seçimini aç/kapa (arama filtresinden bağımsız, ID bazlı)
  /**
   * Bağlantılı dosya seçimi.
   *
   * Boşanma ve mal rejimi dosyalarında eş ve çocuk bilgileri çoğu zaman
   * bağlantılı dosyada zaten yazılıdır; elle ikinci kez girmek hem zaman
   * kaybı hem de yazım farkı kaynağı. Seçim yapıldığında o dosyadan
   * çekiyoruz.
   *
   * ÖNEMLİ: Yalnızca BOŞ alanlar doldurulur. Dolu bir alanın üzerine asla
   * yazılmaz — bu dosyaya elle girilmiş bilgi, başka dosyadan gelenden
   * önceliklidir.
   */
  const toggleLinkedFile = async (fileId) => {
    const id = parseInt(fileId);
    if (Number.isNaN(id)) return;

    const zatenSecili = selectedLinkedFiles.includes(id);
    setSelectedLinkedFiles((prev) =>
      zatenSecili ? prev.filter((x) => x !== id) : [...prev, id]
    );
    setHasChanges(true);

    // Seçim kaldırılıyorsa aktarılacak bir şey yok.
    if (zatenSecili) return;
    // Eş ve çocuk alanları yalnızca boşanma / mal rejimi türlerinde var.
    if (!isBosanmaTuru) return;

    const bos = (v) => v === undefined || v === null || String(v).trim() === '';

    try {
      const d = await caseFileAPI.getById(id);
      if (!d) return;
      const alindi = [];

      setFormData((prev) => {
        const y = { ...prev };
        const esAd = d.EsAdSoyad ?? d.esAdSoyad;
        const esTc = d.EsTC ?? d.esTC;
        const cocukSayisi = d.CocukSayisi ?? d.cocukSayisi;
        if (bos(y.EsAdSoyad) && !bos(esAd)) { y.EsAdSoyad = esAd; alindi.push('eş adı'); }
        if (bos(y.EsTC) && !bos(esTc)) { y.EsTC = esTc; alindi.push('eş T.C.'); }
        if (bos(y.CocukSayisi) && !bos(cocukSayisi)) { y.CocukSayisi = cocukSayisi; }
        return y;
      });

      setCocuklar((prev) => {
        // Bu dosyada çocuk satırı girilmişse dokunulmaz.
        if (prev.length > 0) return prev;
        try {
          const ham = d.CocuklarJson ?? d.cocuklarJson;
          const cozulen = ham ? JSON.parse(ham) : [];
          if (!Array.isArray(cozulen) || cozulen.length === 0) return prev;
          alindi.push(`${cozulen.length} çocuk`);
          return cozulen.map((c) => ({
            adSoyad: c.adSoyad || c.AdSoyad || '',
            dogumTarihi: formatDateForDateInput(c.dogumTarihi || c.DogumTarihi || '')
          }));
        } catch {
          return prev;
        }
      });

      setAktarimNotu(
        alindi.length > 0
          ? `Bağlantılı dosyadan alındı: ${alindi.join(', ')}. Dolu alanlara dokunulmadı.`
          : 'Bağlantılı dosyada aktarılacak boş alan bulunamadı.'
      );
    } catch (_) {
      setAktarimNotu('Bağlantılı dosyanın bilgileri alınamadı; alanları elle girebilirsiniz.');
    }
  };

  // Dosya türüne göre zorunlu alan kontrolü
  const requiresVehicleFields = () => {
    const davaTuru = parseInt(formData.DavaTuru) || 0;
    return [
      DAVA_TURU.TrafikKazasi,           // 1 - Trafik Kazası
      DAVA_TURU.GeciciIsGormezlik,      // 3 - Geçici İş Görmezlik
      DAVA_TURU.MaddiHasar,             // 5 - Maddi Hasar
      DAVA_TURU.DegerKaybi,             // 6 - Değer Kaybı
      DAVA_TURU.MaddiHasarDegerKaybi,   // 7 - Maddi Hasar-Değer Kaybı
      DAVA_TURU.KazancKaybi,            // 8 - Kazanç Kaybı
      DAVA_TURU.Kasko,                  // 9 - Kasko
      DAVA_TURU.MaddiHasarImms,         // 10 - Maddi Hasar İMMS
      DAVA_TURU.DegerKaybiImms,         // 11 - Değer Kaybı İMMS
      DAVA_TURU.DestekYoksunKalma,      // 12 - Destekten Yoksun Kalma
      DAVA_TURU.TrafikKazasiMaluliyet,  // 13 - Trafik Kazası Maluliyet
      DAVA_TURU.TrafikKazasiVefat,      // 14 - Trafik Kazası Vefat
      DAVA_TURU.TrafikIsKazasiMaluliyet, // 21 - Trafik İş Kazası Maluliyet
      DAVA_TURU.TrafikIsKazasiVefat,    // 22 - Trafik İş Kazası Vefat
      DAVA_TURU.AracMahrumiyetBedeli,    // 48 - Araç Mahrumiyet (dava)
      DAVA_TURU.AracMahrumiyetBedeliIcraTakip, // 51 - Araç Mahrumiyet (icra takip)
      DAVA_TURU.MaddiHasarDegerKaybiAracMahrumiyet // 49 - Maddi Hasar - Değer Kaybı - Araç Mahrumiyet
    ].includes(davaTuru);
  };

  // İcra takip bilgileri otomatik gösterilen dosya türleri
  const requiresIcraTakip = (davaTuru) => {
    const davaTuruInt = parseInt(davaTuru) || 0;
    return [
      DAVA_TURU.IcraDava,
      DAVA_TURU.IcraTaki,
      DAVA_TURU.AracMahrumiyetBedeliIcraTakip
    ].includes(davaTuruInt);
  };

  const showIcraTakipSection = () => {
    return requiresIcraTakip(formData.DavaTuru) || icraTakipBilgisiEkle;
  };

  // Belirli dava türleri için zaman aşımı tarihi otomatik hesaplama gerektirir (2 yıl)
  const requiresAutoZamanAsimi = (davaTuru) => {
    const davaTuruInt = parseInt(davaTuru) || 0;
    return [
      DAVA_TURU.MaddiHasar,                      // 5 - Maddi Hasar
      DAVA_TURU.DegerKaybi,                      // 6 - Değer Kaybı
      DAVA_TURU.MaddiHasarDegerKaybi,           // 7 - Maddi Hasar-Değer Kaybı
      DAVA_TURU.MaddiHasarDegerKaybiAracMahrumiyet, // 49 - Maddi Hasar - Değer Kaybı - Araç Mahrumiyet
      DAVA_TURU.KazancKaybi,                     // 8 - Kazanç Kaybı
      DAVA_TURU.MaddiHasarImms,                  // 10 - Maddi Hasar İMMS
      DAVA_TURU.DegerKaybiImms                   // 11 - Değer Kaybı İMMS
    ].includes(davaTuruInt);
  };

  // Belirli dava türleri için zaman aşımı tarihi otomatik hesaplama gerektirir (8 yıl)
  const requiresAutoZamanAsimi8Yil = (davaTuru) => {
    const davaTuruInt = parseInt(davaTuru) || 0;
    return [
      DAVA_TURU.TrafikKazasiMaluliyet,           // 13 - Trafik Kazası Maluliyet
      DAVA_TURU.GeciciIsGormezlik                 // 3 - Geçici İş Göremezlik
    ].includes(davaTuruInt);
  };

  // Trafik Kazası Maluliyet: rapor tarihi = kaza tarihi + 1 yıl
  const requiresAutoRaporTarihi1Yil = (davaTuru) => {
    const davaTuruInt = parseInt(davaTuru) || 0;
    return davaTuruInt === DAVA_TURU.TrafikKazasiMaluliyet;
  };

  // Belirli dava türleri için zaman aşımı tarihi otomatik hesaplama gerektirir (15 yıl)
  const requiresAutoZamanAsimi15Yil = (davaTuru) => {
    const davaTuruInt = parseInt(davaTuru) || 0;
    return [
      DAVA_TURU.TrafikKazasiVefat,                // 14 - Trafik Kazası Vefat
      DAVA_TURU.DestekYoksunKalma                 // 12 - Destek Yoksun Kalma
    ].includes(davaTuruInt);
  };

  // Kaza tarihinden belirtilen yıl kadar sonrasını hesapla (zaman aşımı tarihi için)
  const calculateZamanAsimiTarihi = (kazaTarihi, yilSayisi = 2) => {
    if (!kazaTarihi || kazaTarihi.trim() === '') {
      return '';
    }
    
    try {
      // YYYY-MM-DD formatında tarih al
      const date = new Date(kazaTarihi);
      if (isNaN(date.getTime())) {
        return '';
      }
      
      // Belirtilen yıl kadar ekle
      const zamanAsimiTarihi = new Date(date);
      zamanAsimiTarihi.setFullYear(zamanAsimiTarihi.getFullYear() + yilSayisi);
      
      // YYYY-MM-DD formatına çevir
      const year = zamanAsimiTarihi.getFullYear();
      const month = String(zamanAsimiTarihi.getMonth() + 1).padStart(2, '0');
      const day = String(zamanAsimiTarihi.getDate()).padStart(2, '0');
      
      return `${year}-${month}-${day}`;
    } catch (e) {
      return '';
    }
  };

  const sulhDurumlari = [
    '',
    'SULH GÖRÜŞMESİ YAPILIYOR',
    'SULH OLUMSUZ',
    'SULH OLUNDU'
  ];

  const ibraAsamalari = [
    '',
    'MÜVEKKİL İBRASI HAZIRLANACAK',
    'MÜVEKKİL İBRASI GÖNDERİLDİ',
    'MÜVEKKİL İBRASI GELDİ',
    'SİGORTA İBRASI GELDİ',
    'SİGORTA İBRA KONTROL',
    'SİGORTA İBRA GÖNDERİLDİ',
    'SİGORTA ŞİRKET İBRASI ONAY BEKLIYOR'
  ];

  const gelenOdemeDurumlari = [
    '',
    'ÖDEME BEKLENİYOR',
    'SULH ÖDEME GELDİ',
    'İCRA ÖDEME GELDİ',
    'HASAR ÖDEME GELDİ',
    'TAHKİM ÖDEME GELDİ',
    'KISMİ ÖDEME GELDİ',
    'HARİCEN TAHSİL'
  ];

  const gidenOdemeDurumlari = [
    '',
    'MÜVEKKİL ÖDEMESİ YAPILACAK',
    'MÜVEKKİL ÖDEMESİ YAPILDI',
    'MÜVEKKİL ÖDEMESİ YAPILAMIYOR'
  ];

  const smmDurumlari = [
    '',
    'MAKBUZ KESİLECEK',
    'MAKBUZ KESİLDİ',
    'MAKBUZ İPTAL EDİLDİ',
    'MAKBUZ KESİLEMİYOR'
  ];

  const turkiyeIlleri = [
    '',
    'Adana',
    'Adıyaman',
    'Afyonkarahisar',
    'Ağrı',
    'Amasya',
    'Ankara',
    'Antalya',
    'Artvin',
    'Aydın',
    'Balıkesir',
    'Bilecik',
    'Bingöl',
    'Bitlis',
    'Bolu',
    'Burdur',
    'Bursa',
    'Çanakkale',
    'Çankırı',
    'Çorum',
    'Denizli',
    'Diyarbakır',
    'Edirne',
    'Elazığ',
    'Erzincan',
    'Erzurum',
    'Eskişehir',
    'Gaziantep',
    'Giresun',
    'Gümüşhane',
    'Hakkari',
    'Hatay',
    'Isparta',
    'İçel (Mersin)',
    'İstanbul',
    'İzmir',
    'Kars',
    'Kastamonu',
    'Kayseri',
    'Kırklareli',
    'Kırşehir',
    'Kocaeli',
    'Konya',
    'Kütahya',
    'Malatya',
    'Manisa',
    'Kahramanmaraş',
    'Mardin',
    'Muğla',
    'Muş',
    'Nevşehir',
    'Niğde',
    'Ordu',
    'Rize',
    'Sakarya',
    'Samsun',
    'Siirt',
    'Sinop',
    'Sivas',
    'Tekirdağ',
    'Tokat',
    'Trabzon',
    'Tunceli',
    'Şanlıurfa',
    'Uşak',
    'Van',
    'Yozgat',
    'Zonguldak',
    'Aksaray',
    'Bayburt',
    'Karaman',
    'Kırıkkale',
    'Batman',
    'Şırnak',
    'Bartın',
    'Ardahan',
    'Iğdır',
    'Yalova',
    'Karabük',
    'Kilis',
    'Osmaniye',
    'Düzce'
  ];

  // Sigorta şirketleri listesi - alfabetik sıralı, "Diğer" en altta
  const sigortaSirketleriRaw = [
    'ACIBADEM SAĞLIK VE HAYAT SİGORTA A.Ş.',
    'AGESA HAYAT VE EMEKLİLİK',
    'AEGON SİGORTA A.Ş.',
    'AKSİGORTA A.Ş.',
    'ALLIANZ HAYAT VE EMEKLİLİK A.Ş.',
    'ALLIANZ SİGORTA A.Ş.',
    'ALLIANZ YAŞAM VE EMEKLİLİK A.Ş.',
    'ANA SİGORTA A.Ş.',
    'ANADOLU ANONİM TÜRK SİGORTA ŞİRKETİ',
    'ANADOLU HAYAT EMEKLİLİK A.Ş.',
    'ANKARA ANONİM TÜRK SİGORTA ŞİRKETİ',
    'AREX SİGORTA A.Ş.',
    'AVEON GLOBAL SİGORTA',
    'AXA HAYAT VE EMEKLİLİK A.Ş.',
    'AXA SİGORTA A.Ş.',
    'BEREKET EMEKLİLİK VE HAYAT A.Ş.',
    'BEREKET KATILIM SİGORTA A.Ş.',
    'BEREKET SİGORTA A.Ş.',
    'BNP PARIBAS CARDIF EMEKLİLİK',
    'BNP PARIBAS CARDIF HAYAT SİGORTA A.Ş.',
    'BNP PARIBAS CARDIF SİGORTA',
    'CHUBB EUROPEAN GROUP LIMITED',
    'CİV HAYAT SİGORTA A.Ş.',
    'COFACE SİGORTA',
    'CORPUS SİGORTA A.Ş.',
    'DEMİR HAYAT SİGORTA A.Ş.',
    'DOĞAL AFET SİGORTALARI KURUMU',
    'DOĞA SİGORTA A.Ş.',
    'DUBAI STARR SİGORTA A.Ş.',
    'ERGO EMEKLİLİK VE HAYAT A.Ş.',
    'ERGO SİGORTA A.Ş.',
    'ETHICA SİGORTA A.Ş.',
    'EGE SİGORTA A.Ş.',
    'FİBA EMEKLİLİK A.Ş.',
    'GARANTİ EMEKLİLİK VE HAYAT A.Ş.',
    'GENERALİ SİGORTA A.Ş.',
    'GRİ SİGORTA A.Ş.',
    'GROUPAMA HAYAT A.Ş.',
    'GROUPAMA SİGORTA A.Ş.',
    'GULF SİGORTA A.Ş.',
    'GÜVENCE HESABI',
    'HDI SİGORTA A.Ş.',
    'HEPİYİ SİGORTA',
    'HÜR SİGORTA A.Ş.',
    'ING EMEKLİLİK VE HAYAT SİGORTA A.Ş.',
    'KORU SİGORTA A.Ş.',
    'LIBERTY SİGORTA A.Ş.',
    'MAGDEBURGER SİGORTA A.Ş.',
    'MAPFRE YAŞAM SİGORTA A.Ş.',
    'MAPFRE SİGORTA A.Ş.',
    'METLİFE EMEKLİLİK VE HAYAT A.Ş.',
    'NEOVA KATILIM SİGORTA A.Ş.',
    'NN HAYAT VE EMEKLİLİK',
    'ORİENT SİGORTA A.Ş.',
    'QUICK SİGORTA A.Ş.',
    'RAY SİGORTA A.Ş.',
    'S.S. ATLAS SİGORTA KOOPERATİFİ',
    'SOMPO SİGORTA A.Ş.',
    'ŞEKER SİGORTA A.Ş.',
    'TARIM SİGORTALARI HAVUZ İŞLETMESİ A.Ş.',
    'TURINS SİGORTA',
    'TÜRK NİPPON SİGORTA A.Ş.',
    'TÜRKİYE HAYAT VE EMEKLİLİK A.Ş.',
    'TÜRKİYE MOTORLU TAŞIT BÜROSU',
    'TÜRKİYE SİGORTA A.Ş.',
    'UNICO SİGORTA A.Ş.',
    'YAPI KREDİ SİGORTA A.Ş.',
    'ZURICH SİGORTA A.Ş.'
  ];
  
  // Alfabetik sıralama (Türkçe karakterler için localeCompare kullan)
  const sigortaSirketleri = [...sigortaSirketleriRaw].sort((a, b) => 
    a.localeCompare(b, 'tr', { sensitivity: 'base' })
  );

  // Not: Yeni dosyada KOPYALANMAYAN dosyaya özel alanlar (kasıtlı olarak boş bırakılır):
  // FoyNo, Status, DavaTuru, DurusmaTarihi, TahkimBasvuruTarihi, SigortaBasvuruTarihi,
  // TahkimBasvuruNo, ItirazBasvuruNo, MahkemaBilgisi, MahkemeEsas, SavcilikCezaDosyaNo,
  // IcraDosyaNo, RaporTarihi, GelenOdemeDurumu, GidenOdemeDurumu, IbraAsamasi, SMM, SulhDurumu.

  // Mevcut dosyalar (tüm dosyalar, tekilleştirme YOK) - yeni dosyada hızlı doldurma için.
  // Her dosya ayrı listelenir; böylece hangi dosyadan kopyalandığı Föy No ile net olur.
  const existingClients = useMemo(() => {
    return (allCaseFiles || [])
      .map((f) => {
        const name = (f.Muvekkil ?? f.muvekkil ?? '').trim();
        if (!name) return null;
        const tc = (f.MuvekkilTC ?? f.muvekkilTC ?? '').trim();
        const fid = f.Id ?? f.id ?? 0;
        const foyNo = (f.FoyNo ?? f.foyNo ?? '').toString().trim();
        return {
          key: `${fid}`,
          Muvekkil: name,
          MuvekkilTC: tc,
          FoyNo: foyNo,
          sourceFileId: fid,
          sourceFile: f,
        };
      })
      .filter(Boolean)
      .sort((a, b) => {
        // Önce müvekkil adına, sonra föy numarasına göre sırala
        const nameCmp = a.Muvekkil.localeCompare(b.Muvekkil, 'tr', { sensitivity: 'base' });
        if (nameCmp !== 0) return nameCmp;
        return a.FoyNo.localeCompare(b.FoyNo, 'tr', { numeric: true });
      });
  }, [allCaseFiles]);

  const [clientSearchTerm, setClientSearchTerm] = useState('');
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [selectedSourceFile, setSelectedSourceFile] = useState(null);
  const [sourceDocuments, setSourceDocuments] = useState([]);
  const [sourceDocsLoading, setSourceDocsLoading] = useState(false);
  const [sourceDocsExpanded, setSourceDocsExpanded] = useState(false);
  const [selectedSourceDocIds, setSelectedSourceDocIds] = useState([]);

  // Arama terimine göre filtrelenmiş dosya listesi (isim, TC veya Föy No)
  const filteredExistingClients = useMemo(() => {
    const term = clientSearchTerm.trim().toLocaleLowerCase('tr-TR');
    if (!term) return existingClients;
    return existingClients.filter((c) =>
      c.Muvekkil.toLocaleLowerCase('tr-TR').includes(term) ||
      (c.MuvekkilTC && c.MuvekkilTC.includes(term)) ||
      (c.FoyNo && c.FoyNo.toLocaleLowerCase('tr-TR').includes(term))
    );
  }, [clientSearchTerm, existingClients]);

  const selectExistingClient = async (client) => {
    if (!client || !client.sourceFile) return;
    const f = client.sourceFile;
    const g = (pas, cam) => f[pas] ?? f[cam] ?? '';

    // KarsiTarafSigortaSirketi eski isimlendirmeyi de dikkate al
    const karsiSigorta = f.KarsiTarafSigortaSirketi ?? f.karsiTarafSigortaSirketi ?? f.KarsiSigorta ?? f.karsiSigorta ?? '';
    const muvekkilSigorta = g('MuvekkilAracSigortaSirketi', 'muvekkilAracSigortaSirketi');
    const vekaletTuru = g('VekaletTuru', 'vekaletTuru');

    setFormData((prev) => ({
      ...prev,
      // Müvekkil bilgileri
      Muvekkil: g('Muvekkil', 'muvekkil'),
      MuvekkilTC: g('MuvekkilTC', 'muvekkilTC'),
      IsSirket: !!(f.IsSirket ?? f.isSirket),
      MuvekkilTelefon: g('MuvekkilTelefon', 'muvekkilTelefon'),
      MuvekkilAdres: g('MuvekkilAdres', 'muvekkilAdres'),
      SirketYetkilisiAdi: g('SirketYetkilisiAdi', 'sirketYetkilisiAdi'),
      SirketYetkilisiTC: g('SirketYetkilisiTC', 'sirketYetkilisiTC'),
      MuvekkilIBAN: g('MuvekkilIBAN', 'muvekkilIBAN'),
      MuvekkilPlaka: g('MuvekkilPlaka', 'muvekkilPlaka'),
      MuvekkilAracRolu: g('MuvekkilAracRolu', 'muvekkilAracRolu'),
      MuvekkilAracSigortaSirketi: muvekkilSigorta,
      // Karşı taraf bilgileri
      KarsiTarafSigortaSirketi: karsiSigorta,
      KarsiTarafPlaka: g('KarsiTarafPlaka', 'karsiTarafPlaka'),
      KarsiTaraf1: g('KarsiTaraf1', 'karsiTaraf1'),
      KarsiTaraf2: g('KarsiTaraf2', 'karsiTaraf2'),
      KarsiTarafSigortaSirketiVekili: g('KarsiTarafSigortaSirketiVekili', 'karsiTarafSigortaSirketiVekili'),
      // Kaza / genel bilgiler
      KazaSehri: g('KazaSehri', 'kazaSehri'),
      KazaTarihi: formatDateForDateInput(f.KazaTarihi ?? f.kazaTarihi),
      DosyaGelisTarihi: formatDateForDateInput(f.DosyaGelisTarihi ?? f.dosyaGelisTarihi),
      ZamanAsimiTarihi: formatDateForDateInput(f.ZamanAsimiTarihi ?? f.zamanAsimiTarihi),
      DavaAcilisTarihi: formatDateForDateInput(f.DavaAcilisTarihi ?? f.davaAcilisTarihi),
      ReferansId: f.ReferansId ?? f.referansId ?? null,
      SozlesmeOrani: g('SozlesmeOrani', 'sozlesmeOrani'),
      SozlesmeOraniKdvDahil: !!(f.SozlesmeOraniKdvDahil ?? f.sozlesmeOraniKdvDahil),
      SorumluId: f.SorumluId ?? f.sorumluId ?? null,
      // Vekalet bilgileri
      VekaletTuru: vekaletTuru,
      VekaletBitisTarihi: formatDateForDateInput(f.VekaletBitisTarihi ?? f.vekaletBitisTarihi),
      VekaletinAsliVar: f.VekaletinAsliVar ?? f.vekaletinAsliVar ?? false,
    }));

    // Sigorta "Diğer" gösterimlerini değere göre ayarla (elle girilen değerler aynen aktarılsın)
    setShowOtherMuvekkilSigorta(!!(muvekkilSigorta && !sigortaSirketleri.includes(muvekkilSigorta)));
    setShowOtherSigorta(!!(karsiSigorta && !sigortaSirketleri.includes(karsiSigorta)));
    setShowVekaletBitisTarihi(vekaletTuru === 'Süreli');

    setClientSearchTerm(client.FoyNo ? `${client.FoyNo} - ${client.Muvekkil}` : client.Muvekkil);
    setShowClientDropdown(false);
    setSelectedSourceFile(f);
    setSourceDocuments([]);
    setSelectedSourceDocIds([]);
    setSourceDocsExpanded(false);
    setSourceDocsLoading(false);
    setHasChanges(true);

    const srcId = f.Id ?? f.id;

    // Vekalet bilgileri liste objesinde olmayabilir; kaynak dosyadan API ile getir
    if (srcId) {
      try {
        const vekalet = await vekaletAPI.getByCaseFileId(srcId);
        if (vekalet) {
          const vTuru = vekalet.VekaletTuru ?? vekalet.vekaletTuru ?? '';
          setFormData((prev) => ({
            ...prev,
            VekaletTuru: vTuru,
            VekaletBitisTarihi: formatDateForDateInput(vekalet.VekaletBitisTarihi ?? vekalet.vekaletBitisTarihi),
            VekaletinAsliVar: vekalet.VekaletinAsliVar ?? vekalet.vekaletinAsliVar ?? false,
          }));
          setShowVekaletBitisTarihi(vTuru === 'Süreli');
        }
      } catch (vErr) {
        // Vekalet yoksa devam et
      }
    }

    // Kaynak dosyanın evrak listesini getir (checkbox ile seçim için)
    try {
      if (srcId) {
        setSourceDocsLoading(true);
        const docs = await documentAPI.getByCaseFile(srcId);
        const list = Array.isArray(docs) ? docs : [];
        setSourceDocuments(list);
        // Varsayılan: hepsi seçili; kullanıcı kaldırabilir
        setSelectedSourceDocIds(list.map((d) => d.Id ?? d.id).filter(Boolean));
        setSourceDocsExpanded(list.length > 0);
      }
    } catch (err) {
      setSourceDocuments([]);
      setSelectedSourceDocIds([]);
    } finally {
      setSourceDocsLoading(false);
    }
  };

  const clearExistingClientSelection = () => {
    setClientSearchTerm('');
    setSelectedSourceFile(null);
    setSourceDocuments([]);
    setSelectedSourceDocIds([]);
    setSourceDocsExpanded(false);
    setShowClientDropdown(false);
  };

  useEffect(() => {
    // Token kontrolü - localStorage'dan da kontrol et
    const localToken = localStorage.getItem('token');
    if (!localToken) {
      // Token yoksa API çağrıları yapma
      return;
    }
    
    loadReferanslar();
    loadUsers();
    loadAllCaseFiles();
    foyTouchedRef.current = false;
  }, [ozelMode]);

  // Yeni dosya oluştururken Föy No: dosyalar yüklendikten sonra max + 1
  useEffect(() => {
    if (caseFile) return;
    if (loadingCaseFiles) return;
    if (foyTouchedRef.current) return;
    let maxFoy = 0;
    for (const f of allCaseFiles || []) {
      const raw = (f.FoyNo ?? f.foyNo ?? '').toString();
      const num = parseInt(raw, 10);
      if (!isNaN(num) && num > maxFoy) maxFoy = num;
    }
    const next = String(maxFoy + 1);
    setFormData((prev) => {
      if (prev.FoyNo === next) return prev;
      return { ...prev, FoyNo: next };
    });
  }, [allCaseFiles, caseFile, loadingCaseFiles]);

  const loadAllCaseFiles = async () => {
    try {
      setLoadingCaseFiles(true);
      // Özel modda yalnızca özel dosyalar; normalde yalnızca normal dosyalar (diğer grup karışmaz)
      const data = await caseFileAPI.getAll(!!ozelMode);
      setAllCaseFiles(data || []);
    } catch (error) {
      console.error('Dosyalar yüklenirken hata:', error);
      // 401 hatası durumunda sessizce geç (interceptor login'e yönlendirmeyecek)
      // Form açılmaya devam etsin, sadece bu veri yüklenmeyecek
      if (error.response?.status === 401) {
        // Sessizce geç, form açılmaya devam etsin
        return;
      }
    } finally {
      setLoadingCaseFiles(false);
    }
  };

  const loadUsers = async () => {
    try {
      setLoadingUsers(true);
      const data = await userAPI.getAll();
      setUsers(data || []);
    } catch (error) {
      console.error('Kullanıcılar yüklenirken hata:', error);
      // 401 hatası durumunda sessizce geç (interceptor login'e yönlendirmeyecek)
      // Form açılmaya devam etsin, sadece bu veri yüklenmeyecek
      if (error.response?.status === 401) {
        // Sessizce geç, form açılmaya devam etsin
        return;
      }
    } finally {
      setLoadingUsers(false);
    }
  };

  const loadReferanslar = async () => {
    try {
      setLoadingReferanslar(true);
      const data = await referansAPI.getAll();
      setReferanslar((data || []).filter(r => (r.isActive ?? r.IsActive) !== false));
    } catch (error) {
      console.error('Referanslar yüklenirken hata:', error);
      // 401 hatası durumunda sessizce geç (interceptor login'e yönlendirmeyecek)
      // Form açılmaya devam etsin, sadece bu veri yüklenmeyecek
      if (error.response?.status === 401) {
        // Sessizce geç, form açılmaya devam etsin
        return;
      }
    } finally {
      setLoadingReferanslar(false);
    }
  };

  useEffect(() => {
    if (!caseFile) return;

    let cancelled = false;

    // Mevcut değer listede yoksa "Diğer" modunu aktif et
    const sigortaValue = caseFile.KarsiTarafSigortaSirketi ?? caseFile.karsiTarafSigortaSirketi ?? caseFile.KarsiSigorta ?? caseFile.karsiSigorta ?? '';
    if (sigortaValue && !sigortaSirketleri.includes(sigortaValue)) {
      setShowOtherSigorta(true);
    }
    const muvekkilSigortaValue = caseFile.MuvekkilAracSigortaSirketi ?? caseFile.muvekkilAracSigortaSirketi ?? '';
    if (muvekkilSigortaValue && !sigortaSirketleri.includes(muvekkilSigortaValue)) {
      setShowOtherMuvekkilSigorta(true);
    }

    const loadForm = async () => {
      // Vekalet ayrı tabloda; API'den yükle (camelCase/PascalCase destekli)
      let vekaletTuru = caseFile.VekaletTuru ?? caseFile.vekaletTuru ?? '';
      let vekaletBitisTarihi = formatDateForDateInput(caseFile.VekaletBitisTarihi ?? caseFile.vekaletBitisTarihi);
      let vekaletinAsliVar = !!(caseFile.VekaletinAsliVar ?? caseFile.vekaletinAsliVar);

      const caseFileId = caseFile.Id ?? caseFile.id;
      if (caseFileId) {
        try {
          const vekalet = await vekaletAPI.getByCaseFileId(caseFileId);
          if (vekalet) {
            vekaletTuru = vekalet.VekaletTuru ?? vekalet.vekaletTuru ?? '';
            vekaletBitisTarihi = formatDateForDateInput(
              vekalet.VekaletBitisTarihi ?? vekalet.vekaletBitisTarihi
            );
            vekaletinAsliVar = !!(vekalet.VekaletinAsliVar ?? vekalet.vekaletinAsliVar);
          }
        } catch {
          // Vekalet yoksa devam et
        }
      }

      if (cancelled) return;

      setFormData({
        FoyNo: caseFile.FoyNo ?? caseFile.foyNo ?? '',
        Muvekkil: caseFile.Muvekkil ?? caseFile.muvekkil ?? '',
        MuvekkilTC: caseFile.MuvekkilTC ?? caseFile.muvekkilTC ?? '',
        IsSirket: !!(caseFile.IsSirket ?? caseFile.isSirket),
        MuvekkilTelefon: caseFile.MuvekkilTelefon ?? caseFile.muvekkilTelefon ?? '',
        MuvekkilAdres: caseFile.MuvekkilAdres ?? caseFile.muvekkilAdres ?? '',
        SirketYetkilisiAdi: caseFile.SirketYetkilisiAdi ?? caseFile.sirketYetkilisiAdi ?? '',
        SirketYetkilisiTC: caseFile.SirketYetkilisiTC ?? caseFile.sirketYetkilisiTC ?? '',
        MuvekkilIBAN: caseFile.MuvekkilIBAN ?? caseFile.muvekkilIBAN ?? '',
        MuvekkilPlaka: caseFile.MuvekkilPlaka ?? caseFile.muvekkilPlaka ?? '',
        MuvekkilAracRolu: caseFile.MuvekkilAracRolu ?? caseFile.muvekkilAracRolu ?? '',
        MuvekkilAracSigortaSirketi: caseFile.MuvekkilAracSigortaSirketi ?? caseFile.muvekkilAracSigortaSirketi ?? '',
        KarsiTarafSigortaSirketi: caseFile.KarsiTarafSigortaSirketi ?? caseFile.karsiTarafSigortaSirketi ?? caseFile.KarsiSigorta ?? caseFile.karsiSigorta ?? '',
        KarsiTarafPlaka: caseFile.KarsiTarafPlaka ?? caseFile.karsiTarafPlaka ?? '',
        KarsiTaraf1: caseFile.KarsiTaraf1 ?? caseFile.karsiTaraf1 ?? '',
        KarsiTaraf2: caseFile.KarsiTaraf2 ?? caseFile.karsiTaraf2 ?? '',
        KarsiTarafSigortaSirketiVekili: caseFile.KarsiTarafSigortaSirketiVekili ?? caseFile.karsiTarafSigortaSirketiVekili ?? '',
        KazaSehri: caseFile.KazaSehri ?? caseFile.kazaSehri ?? '',
        KazaTarihi: formatDateForDateInput(caseFile.KazaTarihi ?? caseFile.kazaTarihi),
        DosyaGelisTarihi: formatDateForDateInput(caseFile.DosyaGelisTarihi ?? caseFile.dosyaGelisTarihi),
        ZamanAsimiTarihi: (() => {
          const davaTuru = caseFile.DavaTuru ?? caseFile.davaTuru ?? DAVA_TURU.None;
          const kazaTarihi = caseFile.KazaTarihi ?? caseFile.kazaTarihi;
          const mevcutZamanAsimi = caseFile.ZamanAsimiTarihi ?? caseFile.zamanAsimiTarihi;

          if (mevcutZamanAsimi) {
            return formatDateForDateInput(mevcutZamanAsimi);
          }

          if (kazaTarihi) {
            const kazaTarihiFormatted = formatDateForDateInput(kazaTarihi);
            if (requiresAutoZamanAsimi15Yil(davaTuru)) {
              const zamanAsimiTarihi = calculateZamanAsimiTarihi(kazaTarihiFormatted, 15);
              if (zamanAsimiTarihi) return zamanAsimiTarihi;
            } else if (requiresAutoZamanAsimi8Yil(davaTuru)) {
              const zamanAsimiTarihi = calculateZamanAsimiTarihi(kazaTarihiFormatted, 8);
              if (zamanAsimiTarihi) return zamanAsimiTarihi;
            } else if (requiresAutoZamanAsimi(davaTuru)) {
              const zamanAsimiTarihi = calculateZamanAsimiTarihi(kazaTarihiFormatted, 2);
              if (zamanAsimiTarihi) return zamanAsimiTarihi;
            }
          }

          return '';
        })(),
        TahkimBasvuruTarihi: formatDateForDateInput(caseFile.TahkimBasvuruTarihi ?? caseFile.tahkimBasvuruTarihi),
        DurusmaTarihi: formatDateForInput(caseFile.DurusmaTarihi ?? caseFile.durusmaTarihi),
        SigortaBasvuruTarihi: formatDateForDateInput(caseFile.SigortaBasvuruTarihi ?? caseFile.sigortaBasvuruTarihi),
        DavaAcilisTarihi: formatDateForDateInput(caseFile.DavaAcilisTarihi ?? caseFile.davaAcilisTarihi),
        RaporTarihi: (() => {
          const davaTuru = caseFile.DavaTuru ?? caseFile.davaTuru ?? DAVA_TURU.None;
          const kazaTarihi = caseFile.KazaTarihi ?? caseFile.kazaTarihi;
          const mevcutRapor = caseFile.RaporTarihi ?? caseFile.raporTarihi;
          if (requiresAutoRaporTarihi1Yil(davaTuru) && kazaTarihi) {
            const kazaFmt = formatDateForDateInput(kazaTarihi);
            const autoRapor = calculateZamanAsimiTarihi(kazaFmt, 1);
            if (autoRapor) return autoRapor;
          }
          return formatDateForDateInput(mevcutRapor);
        })(),
        FizikiDosyaMevcut: !!(caseFile.FizikiDosyaMevcut ?? caseFile.fizikiDosyaMevcut),
        DavaTuru: caseFile.DavaTuru ?? caseFile.davaTuru ?? DAVA_TURU.None,
        DavaTuruDiger: caseFile.DavaTuruDiger ?? caseFile.davaTuruDiger ?? '',
        ReferansId: caseFile.ReferansId ?? caseFile.referansId ?? null,
        SozlesmeOrani: caseFile.SozlesmeOrani ?? caseFile.sozlesmeOrani ?? '',
        SozlesmeOraniKdvDahil: !!(caseFile.SozlesmeOraniKdvDahil ?? caseFile.sozlesmeOraniKdvDahil),
        TahkimBasvuruNo: caseFile.TahkimBasvuruNo ?? caseFile.tahkimBasvuruNo ?? '',
        ItirazBasvuruNo: caseFile.ItirazBasvuruNo ?? caseFile.itirazBasvuruNo ?? '',
        MahkemaBilgisi: caseFile.MahkemaBilgisi ?? caseFile.mahkemaBilgisi ?? '',
        MahkemeEsas: caseFile.MahkemeEsas ?? caseFile.mahkemeEsas ?? '',
        SavcilikCezaDosyaNo: caseFile.SavcilikCezaDosyaNo ?? caseFile.savcilikCezaDosyaNo ?? '',
        IcraDosyaNo: caseFile.IcraDosyaNo ?? caseFile.icraDosyaNo ?? '',
        GelenOdemeDurumu: caseFile.GelenOdemeDurumu ?? caseFile.gelenOdemeDurumu ?? '',
        GidenOdemeDurumu: caseFile.GidenOdemeDurumu ?? caseFile.gidenOdemeDurumu ?? '',
        IbraAsamasi: caseFile.IbraAsamasi ?? caseFile.ibraAsamasi ?? '',
        SMM: caseFile.SMM ?? caseFile.smm ?? '',
        SulhDurumu: caseFile.SulhDurumu ?? caseFile.sulhDurumu ?? '',
        Status: caseFile.Status ?? caseFile.status ?? CASE_FILE_STATUS.None,
        CaseFileId: caseFile.Id ?? caseFile.id ?? caseFile.CaseFileId ?? null,
        SorumluId: caseFile.SorumluId ?? caseFile.sorumluId ?? null,
        VekaletTuru: vekaletTuru,
        VekaletBitisTarihi: vekaletBitisTarihi,
        VekaletinAsliVar: vekaletinAsliVar,
        TakipAcilisMiktari: caseFile.TakipAcilisMiktari ?? caseFile.takipAcilisMiktari ?? '',
        TakipTarihi: formatDateForDateInput(caseFile.TakipTarihi ?? caseFile.takipTarihi),
        IcraFaizTuru: caseFile.IcraFaizTuru ?? caseFile.icraFaizTuru ?? 'Yasal',
        IcraFaizOrani: (() => {
          const tur = caseFile.IcraFaizTuru ?? caseFile.icraFaizTuru ?? 'Yasal';
          const oran = caseFile.IcraFaizOrani ?? caseFile.icraFaizOrani ?? '';
          if (tur === 'Avans' && (oran === '' || oran == null)) return getGuncelAvansOrani();
          return oran;
        })(),
        IcraFaizBaslangicTarihi: formatDateForDateInput(caseFile.IcraFaizBaslangicTarihi ?? caseFile.icraFaizBaslangicTarihi),
        IcraTahsilAsamasi: caseFile.IcraTahsilAsamasi ?? caseFile.icraTahsilAsamasi ?? 'once',
        IcraVekaletUcretiManuel: caseFile.IcraVekaletUcretiManuel ?? caseFile.icraVekaletUcretiManuel ?? '',
        IcraKonusu: caseFile.IcraKonusu ?? caseFile.icraKonusu ?? '',
        IcraIlamsiz: true,
        BorcluSayisi: 1,
        KesinlesmeTarihi: formatDateForDateInput(caseFile.KesinlesmeTarihi ?? caseFile.kesinlesmeTarihi),
        MuvekkilDavaci: caseFile.MuvekkilDavaci ?? caseFile.muvekkilDavaci ?? false,
        MuvekkilDavali: caseFile.MuvekkilDavali ?? caseFile.muvekkilDavali ?? false,
        EsAdSoyad: caseFile.EsAdSoyad ?? caseFile.esAdSoyad ?? '',
        EsTC: caseFile.EsTC ?? caseFile.esTC ?? '',
        EsCalisiyor: !!(caseFile.EsCalisiyor ?? caseFile.esCalisiyor),
        EvlilikTarihi: formatDateForDateInput(caseFile.EvlilikTarihi ?? caseFile.evlilikTarihi),
        AyrilikTarihi: formatDateForDateInput(caseFile.AyrilikTarihi ?? caseFile.ayrilikTarihi),
        BosanmaSebebi: caseFile.BosanmaSebebi ?? caseFile.bosanmaSebebi ?? '',
        CocukSayisi: caseFile.CocukSayisi ?? caseFile.cocukSayisi ?? '',
        VelayetTalebi: !!(caseFile.VelayetTalebi ?? caseFile.velayetTalebi),
        TalepNafaka: caseFile.TalepNafaka ?? caseFile.talepNafaka ?? false,
        TalepTedbirNafaka: caseFile.TalepTedbirNafaka ?? caseFile.talepTedbirNafaka ?? false,
        TalepIstirakNafaka: caseFile.TalepIstirakNafaka ?? caseFile.talepIstirakNafaka ?? false,
        TalepYoksullukNafaka: caseFile.TalepYoksullukNafaka ?? caseFile.talepYoksullukNafaka ?? false,
        TalepMaddiTazminat: caseFile.TalepMaddiTazminat ?? caseFile.talepMaddiTazminat ?? false,
        TalepManeviTazminat: caseFile.TalepManeviTazminat ?? caseFile.talepManeviTazminat ?? false,
        OdemeBilgileriGoster: !!(caseFile.OdemeBilgileriGoster ?? caseFile.odemeBilgileriGoster),
        DetayAlanGoster: (() => {
          const raw = caseFile.DetayAlanGoster ?? caseFile.detayAlanGoster;
          if (!raw) return {};
          if (typeof raw === 'object' && !Array.isArray(raw)) return raw;
          try {
            const o = JSON.parse(raw);
            return o && typeof o === 'object' && !Array.isArray(o) ? o : {};
          } catch {
            return {};
          }
        })(),
        MuvekkilSanik: !!(caseFile.MuvekkilSanik ?? caseFile.muvekkilSanik),
        MuvekkilMusteki: !!(caseFile.MuvekkilMusteki ?? caseFile.muvekkilMusteki),
        MuvekkilSupheli: !!(caseFile.MuvekkilSupheli ?? caseFile.muvekkilSupheli),
        SucTuru: caseFile.SucTuru ?? caseFile.sucTuru ?? '',
        SucTarihi: formatDateForDateInput(caseFile.SucTarihi ?? caseFile.sucTarihi),
        SucYeri: caseFile.SucYeri ?? caseFile.sucYeri ?? '',
        TckMaddesi: caseFile.TckMaddesi ?? caseFile.tckMaddesi ?? '',
        TedbirTutuklu: !!(caseFile.TedbirTutuklu ?? caseFile.tedbirTutuklu),
        TedbirAdliKontrol: !!(caseFile.TedbirAdliKontrol ?? caseFile.tedbirAdliKontrol),
        TedbirYakalamaKarari: !!(caseFile.TedbirYakalamaKarari ?? caseFile.tedbirYakalamaKarari),
        KovusturmayaYerOlmadigiKarari: !!(caseFile.KovusturmayaYerOlmadigiKarari ?? caseFile.kovusturmayaYerOlmadigiKarari),
        IddianameTarihi: formatDateForDateInput(caseFile.IddianameTarihi ?? caseFile.iddianameTarihi),
        TarafSayisi: caseFile.TarafSayisi ?? caseFile.tarafSayisi ?? '',
        IsverenFirma: caseFile.IsverenFirma ?? caseFile.isverenFirma ?? '',
        IsverenTcvkn: caseFile.IsverenTcvkn ?? caseFile.isverenTcvkn ?? '',
        IsverenYetkilisi: caseFile.IsverenYetkilisi ?? caseFile.isverenYetkilisi ?? '',
        IsverenAdresi: caseFile.IsverenAdresi ?? caseFile.isverenAdresi ?? '',
        SgkSicilNo: caseFile.SgkSicilNo ?? caseFile.sgkSicilNo ?? '',
        IseGirisTarihi: formatDateForDateInput(caseFile.IseGirisTarihi ?? caseFile.iseGirisTarihi),
        IstenCikisTarihi: formatDateForDateInput(caseFile.IstenCikisTarihi ?? caseFile.istenCikisTarihi),
        CikisNedeni: caseFile.CikisNedeni ?? caseFile.cikisNedeni ?? '',
        SonUcret: caseFile.SonUcret ?? caseFile.sonUcret ?? '',
        TalepKidem: !!(caseFile.TalepKidem ?? caseFile.talepKidem),
        TalepIhbar: !!(caseFile.TalepIhbar ?? caseFile.talepIhbar),
        TalepFazlaMesai: !!(caseFile.TalepFazlaMesai ?? caseFile.talepFazlaMesai),
        TalepUbgt: !!(caseFile.TalepUbgt ?? caseFile.talepUbgt),
        TalepHaftaTatili: !!(caseFile.TalepHaftaTatili ?? caseFile.talepHaftaTatili),
        TalepYillikIzin: !!(caseFile.TalepYillikIzin ?? caseFile.talepYillikIzin),
        TalepAgi: !!(caseFile.TalepAgi ?? caseFile.talepAgi),
        TalepMaasAlacagi: !!(caseFile.TalepMaasAlacagi ?? caseFile.talepMaasAlacagi),
        ArabuluculukTarihi: formatDateForDateInput(caseFile.ArabuluculukTarihi ?? caseFile.arabuluculukTarihi),
        SonTutanakTarihi: formatDateForDateInput(caseFile.SonTutanakTarihi ?? caseFile.sonTutanakTarihi),
        ArabuluculukSonucu: caseFile.ArabuluculukSonucu ?? caseFile.arabuluculukSonucu ?? '',
        ArabuluculukDosyaNo: caseFile.ArabuluculukDosyaNo ?? caseFile.arabuluculukDosyaNo ?? '',
        IscilikDavaTarihi: formatDateForDateInput(caseFile.IscilikDavaTarihi ?? caseFile.iscilikDavaTarihi),
        BilirkisiTarihi: formatDateForDateInput(caseFile.BilirkisiTarihi ?? caseFile.bilirkisiTarihi),
        IslahTarihi: formatDateForDateInput(caseFile.IslahTarihi ?? caseFile.islahTarihi),
      });

      setShowVekaletBitisTarihi(vekaletTuru === 'Süreli');

      const loadedDavaTuru = caseFile.DavaTuru ?? caseFile.davaTuru ?? DAVA_TURU.None;
      const hasTakipData = !!(
        (caseFile.TakipAcilisMiktari ?? caseFile.takipAcilisMiktari) ||
        (caseFile.TakipTarihi ?? caseFile.takipTarihi) ||
        (caseFile.IcraFaizBaslangicTarihi ?? caseFile.icraFaizBaslangicTarihi) ||
        (caseFile.IcraVekaletUcretiManuel ?? caseFile.icraVekaletUcretiManuel)
      );
      setIcraTakipBilgisiEkle(
        !requiresIcraTakip(loadedDavaTuru) && hasTakipData
      );

      try {
        const rawCocuk = caseFile.CocuklarJson ?? caseFile.cocuklarJson;
        const parsed = rawCocuk ? JSON.parse(rawCocuk) : [];
        setCocuklar(Array.isArray(parsed) ? parsed.map((c) => ({
          adSoyad: c.adSoyad || c.AdSoyad || '',
          dogumTarihi: formatDateForDateInput(c.dogumTarihi || c.DogumTarihi || '')
        })) : []);
      } catch {
        setCocuklar([]);
      }

      try {
        const rawTaraf = caseFile.TaraflarJson ?? caseFile.taraflarJson;
        const parsedT = rawTaraf ? JSON.parse(rawTaraf) : [];
        setTaraflar(Array.isArray(parsedT) ? parsedT.map((t) => ({
          adSoyad: t.adSoyad || t.AdSoyad || '',
          tc: t.tc || t.TC || t.Tc || '',
          rol: t.rol || t.Rol || 'Müşteki'
        })) : []);
      } catch {
        setTaraflar([]);
      }

      try {
        const rawAyar = caseFile.IcraHesapAyar ?? caseFile.icraHesapAyar;
        const ayar = rawAyar ? (typeof rawAyar === 'string' ? JSON.parse(rawAyar) : rawAyar) : {};
        const parsedBorclular = Array.isArray(ayar.borclular)
          ? ayar.borclular.map((b) => ({
              adSoyad: b.adSoyad || b.AdSoyad || '',
              tc: b.tc || b.TC || b.Tc || '',
              adres: b.adres || b.Adres || '',
              isSirket: !!(b.isSirket ?? b.IsSirket)
            }))
          : [];
        const n = Math.max(1, parseInt(ayar.borcluSayisi, 10) || parsedBorclular.length || 1);
        const nextBorclular = [...parsedBorclular];
        while (nextBorclular.length < n) nextBorclular.push(emptyBorclu());
        setBorclular(nextBorclular.slice(0, n));
        setFormData((prev) => ({
          ...prev,
          IcraIlamsiz: ayar.ilamsiz !== false,
          BorcluSayisi: n
        }));
      } catch {
        setBorclular([emptyBorclu()]);
      }

      if (caseFile.LinkedCaseFiles && Array.isArray(caseFile.LinkedCaseFiles)) {
        const linkedFileIds = caseFile.LinkedCaseFiles
          .map(f => f.Id || f.id)
          .filter(id => id != null);
        setSelectedLinkedFiles(linkedFileIds);
        setInitialLinkedFiles(linkedFileIds);
      } else {
        setSelectedLinkedFiles([]);
        setInitialLinkedFiles([]);
      }
    };

    loadForm();
    return () => { cancelled = true; };
  }, [caseFile]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'FoyNo') foyTouchedRef.current = true;
    
    // String alanları büyük harfe çevir (tarih, sayı ve özel alanlar hariç)
    const stringFieldsToUpperCase = [
      'Muvekkil', 'MuvekkilTC', 'MuvekkilTelefon', 'MuvekkilAdres', 'MuvekkilIBAN',
      'SirketYetkilisiAdi', 'SirketYetkilisiTC',
      'KarsiTarafSigortaSirketi', 'KarsiTaraf1', 'KarsiTaraf2',
      'MuvekkilPlaka', 'MuvekkilAracRolu', 'MuvekkilAracSigortaSirketi', 'KarsiTarafPlaka', 
      'SulhDurumu', 'IbraAsamasi', 'GelenOdemeDurumu', 
      'GidenOdemeDurumu', 'SMM', 'MahkemaBilgisi', 'MahkemeEsas',
      'IcraDosyaNo', 'SavcilikCezaDosyaNo', 'TahkimBasvuruNo', 
      'ItirazBasvuruNo', 'KarsiTarafSigortaSirketiVekili',
      'EsAdSoyad', 'EsTC', 'SucTuru', 'SucYeri', 'TckMaddesi',
      'IsverenFirma', 'IsverenTcvkn', 'IsverenYetkilisi', 'IsverenAdresi', 'SgkSicilNo', 'CikisNedeni'
    ];

    const checkboxFields = [
      'VekaletinAsliVar', 'MuvekkilDavaci', 'MuvekkilDavali', 'VelayetTalebi', 'EsCalisiyor',
      'OdemeBilgileriGoster', 'IsSirket', 'FizikiDosyaMevcut',
      'TalepNafaka', 'TalepTedbirNafaka', 'TalepIstirakNafaka',
      'TalepYoksullukNafaka', 'TalepMaddiTazminat', 'TalepManeviTazminat',
      'MuvekkilSanik', 'MuvekkilMusteki', 'MuvekkilSupheli',
      'TedbirTutuklu', 'TedbirAdliKontrol', 'TedbirYakalamaKarari',
      'KovusturmayaYerOlmadigiKarari',
      'TalepKidem', 'TalepIhbar', 'TalepFazlaMesai', 'TalepUbgt',
      'TalepHaftaTatili', 'TalepYillikIzin', 'TalepAgi', 'TalepMaasAlacagi',
      'SozlesmeOraniKdvDahil'
    ];
    
    // Karşı Taraf Sigorta Şirketi için özel kontrol
    if (name === 'KarsiTarafSigortaSirketi') {
      if (value === 'Diğer') {
        setShowOtherSigorta(true);
        setFormData(prev => ({
          ...prev,
          [name]: ''
        }));
      } else {
        setShowOtherSigorta(false);
        setFormData(prev => ({
          ...prev,
          [name]: value.toLocaleUpperCase('tr-TR')
        }));
      }
      return;
    }
    
    // Müvekkil Araç Sigorta Şirketi için özel kontrol
    if (name === 'MuvekkilAracSigortaSirketi') {
      if (value === 'Diğer') {
        setShowOtherMuvekkilSigorta(true);
        setFormData(prev => ({
          ...prev,
          [name]: ''
        }));
      } else {
        setShowOtherMuvekkilSigorta(false);
        setFormData(prev => ({
          ...prev,
          [name]: value.toLocaleUpperCase('tr-TR')
        }));
      }
      return;
    }
    
    if (name === 'KazaSehri') {
      // Kaza Şehri dropdown değerini olduğu gibi bırak (büyük harfe çevirme)
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    } else if (name === 'DavaTuru') {
      // Dava türü değiştiğinde zaman aşımı tarihini otomatik hesapla
      const processedValue = value ? parseInt(value) : null;

      // Otomatik icra takip türü değilse checkbox'ı sıfırla (manuel seçim için)
      if (requiresIcraTakip(processedValue)) {
        setIcraTakipBilgisiEkle(false);
      }
      
      setFormData(prev => {
        const newData = {
          ...prev,
          [name]: processedValue
        };
        
        // Eğer belirli dava türleri seçildiyse ve kaza tarihi varsa, zaman aşımı tarihini otomatik hesapla
        // prev.KazaTarihi kullan (state güncellemesi asenkron olduğu için)
        if (prev.KazaTarihi) {
          // Önce 15 yıl kontrolü yap
          if (requiresAutoZamanAsimi15Yil(processedValue)) {
            const zamanAsimiTarihi = calculateZamanAsimiTarihi(prev.KazaTarihi, 15);
            if (zamanAsimiTarihi) {
              newData.ZamanAsimiTarihi = zamanAsimiTarihi;
            }
          } else if (requiresAutoZamanAsimi8Yil(processedValue)) {
            // Sonra 8 yıl kontrolü yap
            const zamanAsimiTarihi = calculateZamanAsimiTarihi(prev.KazaTarihi, 8);
            if (zamanAsimiTarihi) {
              newData.ZamanAsimiTarihi = zamanAsimiTarihi;
            }
          } else if (requiresAutoZamanAsimi(processedValue)) {
            // Son olarak 2 yıl kontrolü yap
            const zamanAsimiTarihi = calculateZamanAsimiTarihi(prev.KazaTarihi, 2);
            if (zamanAsimiTarihi) {
              newData.ZamanAsimiTarihi = zamanAsimiTarihi;
            }
          }

          if (requiresAutoRaporTarihi1Yil(processedValue)) {
            const raporTarihi = calculateZamanAsimiTarihi(prev.KazaTarihi, 1);
            if (raporTarihi) newData.RaporTarihi = raporTarihi;
          }
        }
        
        return newData;
      });
    } else if (name === 'KazaTarihi') {
      // Kaza tarihi değiştiğinde, eğer belirli dava türleri seçiliyse zaman aşımı tarihini otomatik hesapla
      setFormData(prev => {
        const newData = {
          ...prev,
          [name]: value
        };
        
        // Eğer belirli dava türleri seçildiyse ve kaza tarihi varsa, zaman aşımı tarihini otomatik hesapla
        if (value) {
          // Önce 15 yıl kontrolü yap
          if (requiresAutoZamanAsimi15Yil(prev.DavaTuru)) {
            const zamanAsimiTarihi = calculateZamanAsimiTarihi(value, 15);
            if (zamanAsimiTarihi) {
              newData.ZamanAsimiTarihi = zamanAsimiTarihi;
            }
          } else if (requiresAutoZamanAsimi8Yil(prev.DavaTuru)) {
            // Sonra 8 yıl kontrolü yap
            const zamanAsimiTarihi = calculateZamanAsimiTarihi(value, 8);
            if (zamanAsimiTarihi) {
              newData.ZamanAsimiTarihi = zamanAsimiTarihi;
            }
          } else if (requiresAutoZamanAsimi(prev.DavaTuru)) {
            // Son olarak 2 yıl kontrolü yap
            const zamanAsimiTarihi = calculateZamanAsimiTarihi(value, 2);
            if (zamanAsimiTarihi) {
              newData.ZamanAsimiTarihi = zamanAsimiTarihi;
            }
          }

          if (requiresAutoRaporTarihi1Yil(prev.DavaTuru)) {
            const raporTarihi = calculateZamanAsimiTarihi(value, 1);
            if (raporTarihi) newData.RaporTarihi = raporTarihi;
          }
        }
        
        return newData;
      });
    } else if (name === 'IcraFaizTuru') {
      setFormData(prev => {
        const next = { ...prev, IcraFaizTuru: value };
        if (value === 'Avans' && (!prev.IcraFaizOrani || prev.IcraFaizTuru !== 'Avans')) {
          next.IcraFaizOrani = getGuncelAvansOrani();
        }
        if (value !== 'Avans' && value !== 'Sozlesme') {
          next.IcraFaizOrani = '';
        }
        return next;
      });
    } else if (name === 'VekaletTuru') {
      // Vekalet türü değiştiğinde bitiş tarihi alanını göster/gizle
      const isSureli = value === 'Süreli';
      setShowVekaletBitisTarihi(isSureli);
      setFormData(prev => ({
        ...prev,
        [name]: value,
        VekaletBitisTarihi: isSureli ? prev.VekaletBitisTarihi : ''
      }));
    } else if (checkboxFields.includes(name)) {
      setFormData(prev => ({
        ...prev,
        [name]: checked
      }));
    } else if (name === 'CocukSayisi') {
      setFormData(prev => ({ ...prev, CocukSayisi: value === '' ? '' : Math.max(0, Math.min(20, parseInt(value, 10) || 0)) }));
      if (value !== '') {
        const n = Math.max(0, Math.min(20, parseInt(value, 10) || 0));
        setCocuklar((prev) => {
          const next = [...prev];
          while (next.length < n) next.push({ adSoyad: '', dogumTarihi: '' });
          return next.slice(0, n);
        });
      }
    } else if (name === 'TarafSayisi') {
      setFormData(prev => ({ ...prev, TarafSayisi: value === '' ? '' : Math.max(0, Math.min(30, parseInt(value, 10) || 0)) }));
      if (value !== '') {
        const n = Math.max(0, Math.min(30, parseInt(value, 10) || 0));
        setTaraflar((prev) => {
          const next = [...prev];
          while (next.length < n) next.push({ adSoyad: '', tc: '', rol: 'Müşteki' });
          return next.slice(0, n);
        });
      }
    } else if (name === 'BorcluSayisi') {
      // Alan geçici olarak boş kalabilmeli: kullanıcı önce siliyor, sonra
      // yeni sayıyı yazıyor. Boşken listeye dokunmuyoruz.
      setFormData(prev => ({ ...prev, BorcluSayisi: value === '' ? '' : Math.max(1, Math.min(30, parseInt(value, 10) || 1)) }));
      if (value !== '') {
        const n = Math.max(1, Math.min(30, parseInt(value, 10) || 1));
        setBorclular((prev) => {
          const next = [...prev];
          while (next.length < n) next.push(emptyBorclu());
          return next.slice(0, n);
        });
      }
    } else if (name === 'IcraIlamsiz') {
      setFormData(prev => ({ ...prev, IcraIlamsiz: value === 'true' || value === true }));
    } else {
      // String alanları büyük harfe çevir (Türkçe karakter desteği ile)
      const processedValue = stringFieldsToUpperCase.includes(name) && typeof value === 'string' 
        ? value.toLocaleUpperCase('tr-TR') 
        : value;
      
      setFormData(prev => ({
        ...prev,
        [name]: (name === 'DavaTuru' || name === 'Status' || name === 'ReferansId' || name === 'SorumluId') 
          ? (processedValue ? parseInt(processedValue) : null) 
          : processedValue
      }));
    }
    setHasChanges(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Masraf veya Not formu açıksa veya submit ediliyorsa submit etme (masraf/not eklenirken dosya oluşturulmamalı)
    if (showMasrafForm || isMasrafSubmitting || showNoteForm || isNoteSubmitting) {
      e.stopPropagation();
      return false;
    }
    
    // Validate required fields - tüm eksik alanları topla
    const missingFields = [];
    
    // Her zaman zorunlu alanlar
    if (!formData.FoyNo || formData.FoyNo <= 0) {
      missingFields.push('Foy No (0\'dan büyük olmalıdır)');
    }
    
    // Sadece yeni dosya oluştururken SorumluId zorunlu
    if (!caseFile && (!formData.SorumluId || formData.SorumluId <= 0)) {
      missingFields.push('Dosya Sorumlusu');
    }
    
    // Dava Türü zorunlu
    if (!formData.DavaTuru || parseInt(formData.DavaTuru) === 0) {
      missingFields.push('Dava Türü');
    }
    
    // Dosya Durumu zorunlu
    if (!formData.Status || parseInt(formData.Status) === 0) {
      missingFields.push('Dosya Durumu');
    }
    
    if (!formData.Muvekkil || formData.Muvekkil.trim() === '') {
      missingFields.push('Müvekkil Adı');
    }
    
    // TC / Vergi No zorunlu (sadece yeni dosya oluştururken)
    if (!caseFile && (!formData.MuvekkilTC || formData.MuvekkilTC.trim() === '')) {
      missingFields.push(isSirket ? 'Vergi No' : 'TC Kimlik No');
    }

    // Telefon zorunlu (yalnızca yeni dosyada).
    // Duruşma hatırlatması, WhatsApp bilgilendirmesi ve müvekkilin
    // portala giriş bilgisini alması numaraya bağlı; numarasız açılan
    // dosya bu özelliklerin hiçbirinden yararlanamıyor. Mevcut
    // dosyalarda zorunlu değil — 330 dosyanın çoğunda numara yok ve
    // eski bir dosyayı düzenlemek imkânsız hale gelmemeli.
    if (!caseFile) {
      const tel = String(formData.MuvekkilTelefon || '').replace(/D/g, '');
      if (!tel) missingFields.push('Müvekkil Telefon');
      else if (!(tel.length === 11 && tel.startsWith('05')))
        missingFields.push('Müvekkil Telefon (05XX XXX XX XX biçiminde olmalı)');
    }
    
    // Vekalet Türü zorunlu
    if (!formData.VekaletTuru || formData.VekaletTuru.trim() === '') {
      missingFields.push('Vekalet Türü');
    }

    // Vekalet Türü "Süreli" ise Vekaletname Bitiş Tarihi zorunlu
    if (formData.VekaletTuru === 'Süreli' && (!formData.VekaletBitisTarihi || formData.VekaletBitisTarihi.trim() === '')) {
      missingFields.push('Vekaletname Bitiş Tarihi');
    }
    
    // Aslı Var Mı kontrolü - checkbox olduğu için true/false kontrolü yapıyoruz
    // Kullanıcı checkbox'ı işaretlememişse uyarı ver (false olabilir, bu normal)
    // Bu durumda sadece kontrol ediyoruz, zorunlu değil
    
    // Dosya Geliş Tarihi zorunlu
    if (!formData.DosyaGelisTarihi || formData.DosyaGelisTarihi.trim() === '') {
      missingFields.push('Dosya Geliş Tarihi');
    }
    
    if (!formData.ReferansId || formData.ReferansId <= 0) {
      missingFields.push('Referans');
    }
    
    // Dosya türüne göre zorunlu alan kontrolü
    const davaTuru = parseInt(formData.DavaTuru) || 0;
    const requiresVehicleFields = [
      DAVA_TURU.TrafikKazasi,           // 1 - Trafik Kazası
      DAVA_TURU.GeciciIsGormezlik,      // 3 - Geçici İş Görmezlik
      DAVA_TURU.MaddiHasar,             // 5 - Maddi Hasar
      DAVA_TURU.DegerKaybi,             // 6 - Değer Kaybı
      DAVA_TURU.MaddiHasarDegerKaybi,   // 7 - Maddi Hasar-Değer Kaybı
      DAVA_TURU.KazancKaybi,            // 8 - Kazanç Kaybı
      DAVA_TURU.Kasko,                  // 9 - Kasko
      DAVA_TURU.MaddiHasarImms,         // 10 - Maddi Hasar İMMS
      DAVA_TURU.DegerKaybiImms,         // 11 - Değer Kaybı İMMS
      DAVA_TURU.DestekYoksunKalma,      // 12 - Destekten Yoksun Kalma
      DAVA_TURU.TrafikKazasiMaluliyet,  // 13 - Trafik Kazası Maluliyet
      DAVA_TURU.TrafikKazasiVefat,      // 14 - Trafik Kazası Vefat
      DAVA_TURU.TrafikIsKazasiMaluliyet, // 21 - Trafik İş Kazası Maluliyet
      DAVA_TURU.TrafikIsKazasiVefat,    // 22 - Trafik İş Kazası Vefat
      DAVA_TURU.AracMahrumiyetBedeli,    // 48 - Araç Mahrumiyet (dava)
      DAVA_TURU.AracMahrumiyetBedeliIcraTakip, // 51 - Araç Mahrumiyet (icra takip)
      DAVA_TURU.MaddiHasarDegerKaybiAracMahrumiyet // 49 - Maddi Hasar - Değer Kaybı - Araç Mahrumiyet
    ].includes(davaTuru);
    
    if (requiresVehicleFields) {
      const isYaya = formData.MuvekkilAracRolu === 'Yaya';
      if (!formData.KazaTarihi || formData.KazaTarihi.trim() === '') {
        missingFields.push('Kaza Tarihi (dosya türüne göre zorunlu)');
      }
      if (!formData.KazaSehri || formData.KazaSehri.trim() === '') {
        missingFields.push('Kaza Şehri (dosya türüne göre zorunlu)');
      }
      if (!isYaya && (!formData.MuvekkilPlaka || formData.MuvekkilPlaka.trim() === '')) {
        missingFields.push('Müvekkil Plaka (dosya türüne göre zorunlu)');
      }
      if (!isYaya && (!formData.MuvekkilAracSigortaSirketi || formData.MuvekkilAracSigortaSirketi.trim() === '')) {
        missingFields.push('Müvekkil Araç Sigorta Şirketi (dosya türüne göre zorunlu)');
      }
      if (!formData.KarsiTarafPlaka || formData.KarsiTarafPlaka.trim() === '') {
        missingFields.push('Karşı Taraf Plaka (dosya türüne göre zorunlu)');
      }
      if (!formData.KarsiTarafSigortaSirketi || formData.KarsiTarafSigortaSirketi.trim() === '') {
        missingFields.push('Karşı Taraf Sigorta Şirketi (dosya türüne göre zorunlu)');
      }
      // Zaman Aşımı Tarihi zorunlu (belirli dava türleri için)
      if (!formData.ZamanAsimiTarihi || formData.ZamanAsimiTarihi.trim() === '') {
        missingFields.push('Zaman Aşımı Tarihi (dosya türüne göre zorunlu)');
      }
    }

    if (formData.MuvekkilAracRolu === 'Yolcu' && (!formData.MuvekkilPlaka || formData.MuvekkilPlaka.trim() === '')) {
      if (!missingFields.some((f) => f.includes('Müvekkil Plaka'))) {
        missingFields.push('Müvekkil Plaka (Yolcu seçildiğinde zorunlu)');
      }
    }

    // Boşanma / Mal Rejimi zorunlu alanlar
    const isBosanmaSubmit = [DAVA_TURU.Bosanma, DAVA_TURU.MalRejimininTasfiyesi]
      .includes(parseInt(formData.DavaTuru));
    if (isBosanmaSubmit) {
      if (!formData.EvlilikTarihi || String(formData.EvlilikTarihi).trim() === '') {
        missingFields.push('Evlilik Tarihi');
      }
      const hasMuvekkilAndTc = (formData.Muvekkil || '').trim() && (formData.MuvekkilTC || '').trim();
      if (hasMuvekkilAndTc && cocuklar.length > 0) {
        cocuklar.forEach((c, i) => {
          if (!(c.adSoyad || '').trim()) {
            missingFields.push(`Çocuk ${i + 1} Adı`);
          }
          if (!(c.dogumTarihi || '').trim()) {
            missingFields.push(`Çocuk ${i + 1} Doğum Tarihi`);
          }
        });
      }
    }
    
    // Eğer eksik alan varsa, hepsini tek seferde göster
    if (missingFields.length > 0) {
      const message = 'Lütfen aşağıdaki zorunlu alanları doldurun:\n\n' + 
                      missingFields.map((field, index) => `${index + 1}. ${field}`).join('\n');
      alert(message);
      return;
    }

    // Şirket müvekkil: imza sirküsü ve vergi levhası hatırlatması
    if (!caseFile && isSirket) {
      const devam = await onayla(
        'Şirket müvekkili için imza sirküsü ve vergi levhasını eklemeyi unutmayınız.\n\nDosyayı oluşturmaya devam etmek istiyor musunuz?'
      );
      if (!devam) return;
    }
    
    try {
      // Vekalet bilgilerini ayır
      const { VekaletTuru, VekaletBitisTarihi, VekaletinAsliVar, ...caseFileData } = formData;

      // Mevcut müvekkil dosyasından evrak kopyalama isteği (parent, oluşturma sonrası
      // yönlendirmeden önce sıralı ve eksiksiz kopyalar)
      const submitData = {
        ...caseFileData,
        AyrilikTarihi: formData.AyrilikTarihi || null,
        EsCalisiyor: !!formData.EsCalisiyor,
        OdemeBilgileriGoster: !!formData.OdemeBilgileriGoster
          || !!(formData.GelenOdemeDurumu || formData.GidenOdemeDurumu || formData.IbraAsamasi || formData.SMM || formData.SulhDurumu),
        DetayAlanGoster: (() => {
          const obj = formData.DetayAlanGoster && typeof formData.DetayAlanGoster === 'object'
            ? formData.DetayAlanGoster
            : {};
          const slim = {};
          Object.keys(obj).forEach((k) => { if (obj[k]) slim[k] = true; });
          return Object.keys(slim).length ? JSON.stringify(slim) : null;
        })(),
        VelayetTalebi: !!formData.VelayetTalebi,
        CocuklarJson: cocuklar.length > 0
          ? JSON.stringify(cocuklar.map((c) => ({
              adSoyad: c.adSoyad || '',
              dogumTarihi: c.dogumTarihi || ''
            })))
          : null,
        TaraflarJson: taraflar.length > 0
          ? JSON.stringify(taraflar.map((t) => ({
              adSoyad: t.adSoyad || '',
              tc: t.tc || '',
              rol: t.rol || 'Müşteki'
            })))
          : null,
        TarafSayisi: formData.TarafSayisi === '' || formData.TarafSayisi == null
          ? null
          : parseInt(formData.TarafSayisi, 10),
        KesinlesmeTarihi: toISODateOrNull(formData.KesinlesmeTarihi),
        IcraHesapAyar: showIcraTakipSection()
          ? JSON.stringify({
              ilamsiz: formData.IcraIlamsiz !== false,
              borcluSayisi: Math.max(1, parseInt(formData.BorcluSayisi, 10) || borclular.length || 1),
              borclular: borclular.map((b) => ({
                adSoyad: b.adSoyad || '',
                tc: b.tc || '',
                adres: b.adres || '',
                isSirket: !!b.isSirket
              }))
            })
          : undefined,
        __copyDocumentsFromFileId: (selectedSourceFile && selectedSourceDocIds.length > 0)
          ? (selectedSourceFile.Id ?? selectedSourceFile.id ?? null)
          : null,
        __copyDocumentIds: (selectedSourceFile && selectedSourceDocIds.length > 0)
          ? selectedSourceDocIds
          : null,
      };

      // Önce dosyayı kaydet
      const savedCaseFile = await onSubmit(submitData);
      
      // Dosya kaydedilemediyse çık
      if (!savedCaseFile) {
        return;
      }
      
      // CaseFileId'yi al (farklı property isimlerinden biri olabilir)
      const caseFileId = savedCaseFile.Id || savedCaseFile.id || savedCaseFile.CaseFileId || savedCaseFile.caseFileId;
      
      // Vekalet bilgileri varsa kaydet
      if (VekaletTuru && caseFileId) {
        try {
          // Mevcut vekalet var mı kontrol et
          // getByCaseFileId artık 404 durumunda null döndürüyor, hata fırlatmıyor
          const existingVekalet = await vekaletAPI.getByCaseFileId(caseFileId);
          
          const vekaletData = {
            CaseFileId: caseFileId,
            VekaletTuru: VekaletTuru,
            VekaletBitisTarihi: toISODateOrNull(VekaletBitisTarihi),
            VekaletinAsliVar: VekaletinAsliVar || false
          };
          
          if (existingVekalet) {
            // Güncelle
            const vekaletId = existingVekalet.Id || existingVekalet.id;
            await vekaletAPI.update(vekaletId, vekaletData);
          } else {
            // Yeni oluştur
            await vekaletAPI.create(vekaletData);
          }
        } catch (error) {
          console.error('Vekalet kaydedilirken hata:', error);
          // Vekalet kaydetme hatası kritik değil, sadece uyarı ver
          console.warn('Vekalet bilgileri kaydedilemedi, ancak dosya başarıyla oluşturuldu');
        }
      }

      // Masraf bilgileri varsa kaydet (çoklu masraf desteği)
      if (masrafData && Array.isArray(masrafData) && masrafData.length > 0 && caseFileId) {
        try {
          // Tüm masrafları sırayla kaydet
          for (const masraf of masrafData) {
            const masrafToSave = {
              CaseFileId: caseFileId, // Backend PascalCase bekliyor
              MasrafTuru: masraf.MasrafTuru,
              CustomMasrafTuru: masraf.CustomMasrafTuru,
              Tutar: masraf.Tutar,
              Tarih: masraf.SonTarih || masraf.Tarih, // Son Tarih değeri Tarih olarak kaydedilecek
              MasrafIstenmeTarihi: masraf.MasrafIstenmeTarihi,
              SonTarih: masraf.SonTarih,
              Aciklama: masraf.Aciklama,
              IsGelir: masraf.IsGelir,
              ReferansId: masraf.ReferansId,
              IsBerileVerilen: masraf.IsBerileVerilen
            };
            await masrafAPI.create(masrafToSave);
          }
        } catch (error) {
          console.error('Masraf kaydedilirken hata:', error);
          alert('Masraf kaydedilirken hata oluştu: ' + (error.response?.data?.message || error.message));
        }
      }

      // Not bilgileri varsa kaydet (çoklu not desteği)
      if (noteData && Array.isArray(noteData) && noteData.length > 0 && caseFileId) {
        try {
          // Tüm notları sırayla kaydet
          for (const note of noteData) {
            const noteToSave = {
              ...note,
              caseFileId: caseFileId
            };
            await noteAPI.create(noteToSave);
          }
        } catch (error) {
          console.error('Not kaydedilirken hata:', error);
        }
      }

      // Bağlantılı dosyaları kaydet
      if (caseFileId) {
        try {
          // Mevcut bağlantıları al (düzenleme modunda)
          let existingLinkedFiles = [];
          const isEditMode = caseFile?.Id || caseFile?.id;
          
          if (isEditMode) {
            const currentFileId = caseFile.Id ?? caseFile.id;
            try {
              const currentFile = await caseFileAPI.getById(currentFileId);
              if (currentFile.LinkedCaseFiles || currentFile.linkedCaseFiles) {
                const linkedFiles = currentFile.LinkedCaseFiles || currentFile.linkedCaseFiles || [];
                existingLinkedFiles = linkedFiles.map(f => f.Id || f.id).filter(id => id != null);
              }
            } catch (error) {
              // Dosya bulunamazsa devam et
              console.warn('Mevcut dosya bilgileri alınamadı:', error);
            }
          }
          
          // Bağlantılı dosyaların değişip değişmediğini kontrol et
          // Başlangıç değeri ile karşılaştır
          const sortedSelected = [...selectedLinkedFiles].sort((a, b) => a - b);
          const sortedInitial = [...initialLinkedFiles].sort((a, b) => a - b);
          const linkedFilesChanged = JSON.stringify(sortedSelected) !== JSON.stringify(sortedInitial);
          
          // Eğer düzenleme modundaysak ve bağlantılar değişmemişse, mevcut bağlantıları koru
          if (isEditMode && !linkedFilesChanged) {
            // Kullanıcı bağlantıları değiştirmemiş, mevcut bağlantıları koru - hiçbir şey yapma
          } else if (selectedLinkedFiles.length > 0 || linkedFilesChanged) {
            // Yeni seçilen dosyalar
            const newLinkedFiles = selectedLinkedFiles.filter(id => !existingLinkedFiles.includes(id));
            // Kaldırılan dosyalar
            const removedLinkedFiles = existingLinkedFiles.filter(id => !selectedLinkedFiles.includes(id));
            
            // Yeni bağlantıları ekle
            for (const linkedFileId of newLinkedFiles) {
              try {
                await caseFileAPI.link(caseFileId, linkedFileId);
              } catch (error) {
                console.error(`Dosya bağlantısı oluşturulurken hata (${linkedFileId}):`, error);
              }
            }
            
            // Kaldırılan bağlantıları sil
            for (const linkedFileId of removedLinkedFiles) {
              try {
                await caseFileAPI.unlink(caseFileId, linkedFileId);
              } catch (error) {
                console.error(`Dosya bağlantısı kaldırılırken hata (${linkedFileId}):`, error);
              }
            }
          } else if (!isEditMode && existingLinkedFiles.length > 0) {
            // Sadece yeni dosya oluşturma modunda ve mevcut bağlantılar varsa kaldır
            // (Bu durum normalde olmamalı, ama güvenlik için)
            for (const linkedFileId of existingLinkedFiles) {
              try {
                await caseFileAPI.unlink(caseFileId, linkedFileId);
              } catch (error) {
                console.error(`Dosya bağlantısı kaldırılırken hata (${linkedFileId}):`, error);
              }
            }
          }
          // Eğer hem selectedLinkedFiles hem de existingLinkedFiles boşsa, hiçbir şey yapma
        } catch (error) {
          console.error('Bağlantılı dosyalar kaydedilirken hata:', error);
        }
      }

      // Dosyaları yükle
      if (caseFileId && Object.keys(selectedFiles).length > 0) {
        let uploadedCount = 0;
        let failedCount = 0;
        
        for (const [docType, file] of Object.entries(selectedFiles)) {
          if (file) {
            const documentTypeInt = typeof docType === 'string' ? parseInt(docType) : docType;
            setUploading(prev => ({ ...prev, [docType]: true }));
            
            try {
              // Dosya kontrolü - hem tek dosya hem de array için
              const fileArray = Array.isArray(file) ? file : [file];
              
              // Her dosya için kendi açıklamasını kullan
              const descriptions = fileDescriptions[docType] || {};
              
              // Toplu dosya yükleme - her dosyayı paralel yükle
              const uploadResults = await Promise.allSettled(
                fileArray.map((fileItem, index) => {
                  // Dosya bazlı açıklama varsa onu kullan, yoksa boş string
                  const description = (typeof descriptions === 'object' && descriptions !== null && !Array.isArray(descriptions))
                    ? (descriptions[index] || '')
                    : (typeof descriptions === 'string' ? descriptions : '');
                  return documentAPI.upload(caseFileId, fileItem, description, documentTypeInt);
                })
              );
              
              // Başarılı ve başarısız yüklemeleri ayır
              const successful = uploadResults.filter(r => r.status === 'fulfilled').length;
              const failed = uploadResults.filter(r => r.status === 'rejected');
              
              uploadedCount += successful;
              failedCount += failed.length;
              
              if (failed.length > 0) {
                const errorMessages = failed.map(f => f.reason?.response?.data?.message || f.reason?.message || 'Bilinmeyen hata').join(', ');
                console.error(`Belge yüklenirken hata (${docType}):`, errorMessages);
              }
            } catch (error) {
              console.error(`Belge yüklenirken hata (${docType}):`, error);
              console.error('Error details:', error.response?.data || error.message);
              failedCount++;
            } finally {
              setUploading(prev => ({ ...prev, [docType]: false }));
            }
          }
        }
        
        if (uploadedCount > 0) {
          console.log(`${uploadedCount} belge başarıyla yüklendi`);
        }
        if (failedCount > 0) {
          console.warn(`${failedCount} belge yüklenemedi`);
        }
      }

      // Not: Mevcut müvekkil dosyasından evrak kopyalama, yönlendirme yarışını önlemek için
      // parent handleCreate içinde (yönlendirmeden önce, sıralı) yapılır.
    } catch (error) {
      console.error('Form gönderilirken hata:', error);
      // Hata zaten onSubmit'te gösterilmiş olabilir
    } finally {
      setHasChanges(false);
    }
  };

  const processSelectedFiles = (documentType, files) => {
    if (!files || files.length === 0) return;
    
    // Tüm dosyaları kontrol et
    const fileArray = Array.from(files);
    
    // Çoklu dosya seçimi - tüm dosyaları kaydet
    if (fileArray.length === 1) {
      setSelectedFiles(prev => ({ ...prev, [documentType]: fileArray[0] }));
      // Tek dosya için açıklamayı temizle
      setFileDescriptions(prev => ({ ...prev, [documentType]: { 0: '' } }));
    } else {
      setSelectedFiles(prev => ({ ...prev, [documentType]: fileArray }));
      // Çoklu dosya için her dosya için boş açıklama oluştur
      const descriptions = {};
      fileArray.forEach((_, index) => {
        descriptions[index] = '';
      });
      setFileDescriptions(prev => ({ ...prev, [documentType]: descriptions }));
    }
    setHasChanges(true);
  };

  const handleClose = () => {
    if (hasChanges) {
      setShowCloseConfirm(true);
    } else {
      onCancel();
    }
  };

  const handleConfirmClose = () => {
    setShowCloseConfirm(false);
    onCancel();
  };

  const handleCancelClose = () => {
    setShowCloseConfirm(false);
  };

  const isBosanmaTuru = [DAVA_TURU.Bosanma, DAVA_TURU.MalRejimininTasfiyesi]
    .includes(parseInt(formData.DavaTuru));
  const isCezaTuru = [DAVA_TURU.Ceza, DAVA_TURU.Sorusturma, DAVA_TURU.SavcilikSikayet, DAVA_TURU.SavcilikSorusturma]
    .includes(parseInt(formData.DavaTuru));
  const isIscilikTuru = parseInt(formData.DavaTuru) === DAVA_TURU.IscilikAlacaklari;
  // Araç hasari / deger kaybi hesabinin acilabilecegi dosya turleri
  const isAracHasarTuru = [
    DAVA_TURU.TrafikKazasi, DAVA_TURU.MaddiHasar, DAVA_TURU.DegerKaybi, DAVA_TURU.MaddiHasarDegerKaybi,
    DAVA_TURU.Kasko, DAVA_TURU.MaddiHasarImms, DAVA_TURU.DegerKaybiImms,
  ].includes(parseInt(formData.DavaTuru));

  // İş kazasında davalı taraf işverendir; işçilik alacaklarındaki işveren
  // alanlarının aynısı burada da gerekiyor. Trafik-iş kazası türleri de
  // dahildir — orada hem araç hem işveren bilgisi tutulur.
  const isIsKazasiTuru = [
    DAVA_TURU.IsKazasiVefat,           // 19
    DAVA_TURU.IsKazasiMaluliyet,       // 20
    DAVA_TURU.TrafikIsKazasiMaluliyet, // 21
    DAVA_TURU.TrafikIsKazasiVefat,     // 22
  ].includes(parseInt(formData.DavaTuru));
  const showTrafficFields = !isBosanmaTuru && !isCezaTuru && !isIscilikTuru;

  const fieldPin = (key) => (
    <span
      className="detay-pin-check"
      title="İşaretlenirse dosya detayında boş olsa da görünür"
    >
      <input
        type="checkbox"
        checked={!!(formData.DetayAlanGoster && formData.DetayAlanGoster[key])}
        onChange={(e) => {
          const on = e.target.checked;
          setHasChanges(true);
          setFormData((prev) => {
            const cur = { ...(prev.DetayAlanGoster || {}) };
            if (on) cur[key] = true;
            else delete cur[key];
            return { ...prev, DetayAlanGoster: cur };
          });
        }}
      />
    </span>
  );

  /* Arabuluculuk bloğu (2026-10-07): bütün dosya türlerinde, açılır kapanır.
     Bilgi varsa, işçilik dosyasıysa ya da durum "Arabuluculuk" ise açık gelir. */
  const arabuluculukBilgisi = !!(formData.ArabuluculukTarihi || formData.SonTutanakTarihi
    || formData.ArabuluculukSonucu || formData.ArabuluculukDosyaNo);
  const [arabuluculukAcik, setArabuluculukAcik] = useState(null);
  const arabuluculukAcikMi = arabuluculukAcik ?? (arabuluculukBilgisi || isIscilikTuru
    || parseInt(formData.Status) === CASE_FILE_STATUS.Arabuluculuk);
  const arabuluculukOzeti = (() => {
    const parca = [];
    const tr = (s) => (s ? s.split('-').reverse().join('.') : '');
    if (formData.ArabuluculukTarihi) parca.push('Başvuru ' + tr(formData.ArabuluculukTarihi));
    const s = ARABULUCULUK_SONUC[formData.ArabuluculukSonucu];
    if (s) parca.push(s.ad);
    if (formData.SonTutanakTarihi) parca.push('Son tutanak ' + tr(formData.SonTutanakTarihi));
    return parca.join(' · ');
  })();
  const arabuluculukSonucuSec = (s) => {
    setHasChanges(true);
    setFormData((prev) => ({ ...prev, ArabuluculukSonucu: parseInt(prev.ArabuluculukSonucu, 10) === s ? '' : s }));
  };

  const updateCocuk = (index, field, value) => {
    setCocuklar((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
    setHasChanges(true);
  };

  const updateTaraf = (index, field, value) => {
    setTaraflar((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
    setHasChanges(true);
  };

  const updateBorclu = (index, field, value) => {
    setBorclular((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
    setHasChanges(true);
  };

  return (
    <div className="case-file-form-overlay">
      {showCloseConfirm && (
        <div className="close-confirm-modal">
          <div className="close-confirm-content">
            <h3>Değişiklikleri Kaydetmeden Kapatmak İstiyor Musunuz?</h3>
            <div className="close-confirm-buttons">
              <button type="button" onClick={handleConfirmClose} className="btn btn-danger">
                Evet, Kapat
              </button>
              <button type="button" onClick={handleCancelClose} className="btn btn-secondary">
                İptal
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="case-file-form case-file-form-large">
        <div className="form-header">
          <h2>{caseFile ? 'Dosya Düzenle' : 'Yeni Dosya Ekle'}</h2>
          <button
            type="button"
            onClick={handleClose}
            className="close-form-btn"
            title="Kapat"
          >
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit} className="case-file-form-content">
          <p className="detay-pin-hint">
            Alan yanındaki kutu işaretlenirse, değer boş olsa da dosya detayında görünür.
          </p>
          {/* Mevcut müvekkil seçimi - sadece yeni dosya oluştururken */}
          {!caseFile && existingClients.length > 0 && (
            <div className="existing-client-picker">
              <div className="existing-client-picker-header">
                <span className="existing-client-picker-icon">👤</span>
                <div>
                  <div className="existing-client-picker-title">Mevcut Müvekkil Seç</div>
                  <div className="existing-client-picker-subtitle">
                    Müvekkil adını yazıp arayın; seçtiğinizde dosyaya özel alanlar hariç tüm bilgiler otomatik dolar.
                  </div>
                </div>
              </div>

              <div className="existing-client-search-wrap">
                <span className="existing-client-search-icon">🔍</span>
                <input
                  type="text"
                  className="form-control existing-client-search"
                  placeholder="Föy No, müvekkil adı veya TC ile ara..."
                  value={clientSearchTerm}
                  onChange={(e) => {
                    setClientSearchTerm(e.target.value);
                    setShowClientDropdown(true);
                    setSelectedSourceFile(null);
                    setSourceDocuments([]);
                    setSelectedSourceDocIds([]);
                    setSourceDocsExpanded(false);
                  }}
                  onFocus={() => setShowClientDropdown(true)}
                  onBlur={() => setTimeout(() => setShowClientDropdown(false), 180)}
                />
                {clientSearchTerm && (
                  <button
                    type="button"
                    className="existing-client-clear"
                    onClick={clearExistingClientSelection}
                    title="Temizle"
                  >
                    ×
                  </button>
                )}

                {showClientDropdown && filteredExistingClients.length > 0 && (
                  <ul className="existing-client-dropdown">
                    {filteredExistingClients.slice(0, 50).map((c) => (
                      <li
                        key={c.key}
                        className="existing-client-option"
                        onMouseDown={(e) => { e.preventDefault(); selectExistingClient(c); }}
                      >
                        <span className="eco-name">
                          {c.FoyNo && <span className="eco-foy">{c.FoyNo}</span>}
                          {c.Muvekkil}
                        </span>
                        {c.MuvekkilTC && <span className="eco-tc">TC: {c.MuvekkilTC}</span>}
                      </li>
                    ))}
                  </ul>
                )}

                {showClientDropdown && clientSearchTerm.trim() && filteredExistingClients.length === 0 && (
                  <ul className="existing-client-dropdown">
                    <li className="existing-client-option existing-client-empty">Eşleşen müvekkil bulunamadı</li>
                  </ul>
                )}
              </div>

              {selectedSourceFile && (
                <div className="existing-client-picker-note">
                  ✓ Müvekkil bilgileri dolduruldu. Gerekirse aşağıdan düzenleyebilirsiniz.
                </div>
              )}

              {selectedSourceFile && (
                <div className="existing-client-docs-panel">
                  <button
                    type="button"
                    className="existing-client-docs-toggle"
                    onClick={() => setSourceDocsExpanded((v) => !v)}
                    disabled={sourceDocsLoading || sourceDocuments.length === 0}
                  >
                    <span>
                      {sourceDocsLoading
                        ? 'Evraklar yükleniyor…'
                        : sourceDocuments.length === 0
                          ? 'Önceki dosyada evrak yok'
                          : `Önceki dosyadan evrak seç (${selectedSourceDocIds.length}/${sourceDocuments.length})`}
                    </span>
                    {sourceDocuments.length > 0 && (
                      <span className="existing-client-docs-caret">{sourceDocsExpanded ? '▲' : '▼'}</span>
                    )}
                  </button>

                  {sourceDocsExpanded && sourceDocuments.length > 0 && (
                    <div className="existing-client-docs-list">
                      <div className="existing-client-docs-actions">
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary"
                          onClick={() => setSelectedSourceDocIds(sourceDocuments.map((d) => d.Id ?? d.id).filter(Boolean))}
                        >
                          Tümünü seç
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary"
                          onClick={() => setSelectedSourceDocIds([])}
                        >
                          Hiçbiri
                        </button>
                      </div>
                      {sourceDocuments.map((doc) => {
                        const docId = doc.Id ?? doc.id;
                        const checked = selectedSourceDocIds.includes(docId);
                        const typeLabel = DOCUMENT_TYPE_LABELS[doc.DocumentType ?? doc.documentType ?? 0] || 'Diğer';
                        const name = doc.FileName ?? doc.fileName ?? 'belge';
                        return (
                          <label key={docId} className="existing-client-docs-item">
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={() => {
                                setSelectedSourceDocIds((prev) =>
                                  checked ? prev.filter((id) => id !== docId) : [...prev, docId]
                                );
                              }}
                            />
                            <span className="ecd-name" title={name}>{name}</span>
                            <span className="ecd-type">{typeLabel}</span>
                          </label>
                        );
                      })}
                      <p className="existing-client-docs-hint">
                        İşaretlenen evraklar yeni dosyaya kopyalanır. Hiçbiri seçilmezse evrak eklenmez.
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Grup 1: Föy no - Dosya sorumlusu */}
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <label>Föy No *</label>
                <input
                  type="number"
                  name="FoyNo"
                  value={formData.FoyNo}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Föy No"
                  required
                />
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <label>Dosya Sorumlusu {!caseFile && <span style={{ color: 'red' }}>*</span>}</label>
                <select
                  name="SorumluId"
                  value={formData.SorumluId || ''}
                  onChange={handleChange}
                  className="form-control"
                  required={!caseFile}
                  disabled={loadingUsers || (caseFile && !(user && (user.Role === 'Admin' || user.role === 'Admin')))}
                >
                  <option value="">---------</option>
                  {users.map((usr) => (
                    <option key={usr.Id || usr.id} value={usr.Id || usr.id}>
                      {usr.Name || usr.name || usr.Username || usr.username}
                    </option>
                  ))}
                </select>
                {caseFile && !(user && (user.Role === 'Admin' || user.role === 'Admin')) && (
                  <small style={{ color: '#666', fontSize: '12px' }}>Sadece admin dosya sorumlusunu değiştirebilir</small>
                )}
              </div>
            </div>
          </div>

          {/* Grup 2: Dava türü - Dosya durumu */}
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <label>Dava Türü *</label>
                <select
                  name="DavaTuru"
                  value={formData.DavaTuru}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  {getSortedDavaTuruEntries().map(([value, label]) => (
                    <option key={value} value={value}>{label}</option>
                  ))}
                </select>

                {/* "Diğer" seçildiğinde tür adı elle yazılır. */}
                {parseInt(formData.DavaTuru) === DAVA_TURU.Diger && (
                  <div className="form-group" style={{ marginTop: '10px' }}>
                    <label>Dava Türü (elle yazın) *</label>
                    <input
                      type="text"
                      name="DavaTuruDiger"
                      value={formData.DavaTuruDiger || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Örn: TAPU İPTAL VE TESCİL"
                      maxLength={200}
                      required
                    />
                    <small style={{ color: '#6c757d', display: 'block', marginTop: '4px' }}>
                      Listede bulunmayan dava türünü buraya yazın. Dosya listesinde ve
                      raporlarda bu ad görünecek.
                    </small>
                  </div>
                )}
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <label>Dosya Durumu *</label>
                <select
                  name="Status"
                  value={formData.Status}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  {Object.entries(CASE_FILE_STATUS_LABELS)
                    .sort((a, b) => {
                      // İlk seçenek (0: '------') her zaman en üstte
                      if (a[0] === '0') return -1;
                      if (b[0] === '0') return 1;
                      // Diğer seçenekler alfabetik sıraya göre
                      return a[1].localeCompare(b[1], 'tr', { sensitivity: 'base' });
                    })
                    .map(([value, label]) => (
                      <option key={value} value={value}>{label}</option>
                    ))}
                </select>
              </div>
            </div>
          </div>

          <div
            className="form-row-full"
            style={{
              marginTop: '16px',
              marginBottom: '10px',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: '8px 20px'
            }}
          >
            <label className="bosanma-check-label" style={{ margin: 0 }}>
              <input
                type="checkbox"
                name="FizikiDosyaMevcut"
                checked={!!formData.FizikiDosyaMevcut}
                onChange={handleChange}
              />
              Fiziki dosya mevcut
            </label>
          </div>

          {/* Vekaletnameden doldurma — elle yazmaya alternatif.
              Yalnızca yeni dosyada gösteriliyor. */}
          {!caseFile && (
            <div className="vekalet-tara">
              <div className="vekalet-tara-basi">
                <span className="vekalet-tara-ad">Vekaletnameden doldur</span>
                <span className="vekalet-tara-not">
                  Vekaletnameyi seçin, bilgiler okunup boş alanlara yazılsın.
                </span>
              </div>

              <div className="vekalet-tara-arac">
                <input
                  type="file"
                  accept="application/pdf,image/*"
                  onChange={(e) => {
                    setVekaletDosyasi(e.target.files?.[0] || null);
                    setVekaletSonuc(null);
                  }}
                  className="form-control"
                />
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={vekaletnameyiOku}
                  disabled={!vekaletDosyasi || vekaletOkunuyor}
                >
                  {vekaletOkunuyor ? 'Okunuyor…' : 'Vekaletnameyi Oku'}
                </button>
              </div>

              {vekaletOkunuyor && (
                <p className="vekalet-tara-bilgi">
                  Taranmış belgelerde bu işlem yarım dakikayı bulabilir.
                </p>
              )}

              {vekaletSonuc?.hata && (
                <p className="vekalet-tara-bilgi hata">{vekaletSonuc.hata}</p>
              )}

              {vekaletSonuc && !vekaletSonuc.hata && (
                <div className="vekalet-tara-sonuc">
                  <p className={'vekalet-tara-bilgi' + (vekaletSonuc.dolan.length ? ' basarili' : '')}>
                    {vekaletSonuc.dolan.length
                      ? 'Dolduruldu: ' + vekaletSonuc.dolan.join(', ') + '. Lütfen kontrol edin.'
                      : 'Okundu ama doldurulacak boş alan kalmadı.'}
                  </p>

                  <dl className="vekalet-okunan">
                    {[
                      ['Ad Soyad', vekaletSonuc.okunan.adSoyad],
                      ['TC', vekaletSonuc.okunan.tc
                        ? vekaletSonuc.okunan.tc + (vekaletSonuc.tcGecerli ? '' : ' (geçersiz — yazılmadı)')
                        : null],
                      ['Adres', vekaletSonuc.okunan.adres],
                      ['Telefon', vekaletSonuc.okunan.telefon],
                      ['Doğum tarihi', vekaletSonuc.okunan.dogumTarihi],
                      ['Baba adı', vekaletSonuc.okunan.babaAdi],
                      ['Ana adı', vekaletSonuc.okunan.anaAdi],
                      ['Noter', vekaletSonuc.okunan.noterAdi],
                      ['Vekalet tarihi', vekaletSonuc.okunan.duzenlemeTarihi],
                      ['Vekalet türü', vekaletSonuc.okunan.vekaletTuru],
                      ['Vekalet bitişi', vekaletSonuc.okunan.bitisTarihi],
                    ].filter(([, v]) => v).map(([ad, v]) => (
                      <div key={ad}>
                        <dt>{ad}</dt>
                        <dd>{v}</dd>
                      </div>
                    ))}
                  </dl>
                </div>
              )}
            </div>
          )}

          {/* Şirket müvekkilde vekaletnameyi yetkili imzalar; adı ve TC'si
              müvekkilin vergi numarasıyla karışmasın diye ayrı durur. */}
          {isSirket && (
            <div className="form-row">
              <div className="form-column">
                <div className="form-group">
                  <span className="field-label-with-pin"><span>Şirket Yetkilisi</span>{fieldPin('SirketYetkilisiAdi')}</span>
                  <input
                    type="text"
                    name="SirketYetkilisiAdi"
                    value={formData.SirketYetkilisiAdi}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Vekaletnameyi imzalayan kişi"
                  />
                </div>
              </div>
              <div className="form-column">
                <div className="form-group">
                  <span className="field-label-with-pin"><span>Yetkili TC</span>{fieldPin('SirketYetkilisiTC')}</span>
                  <input
                    type="text"
                    name="SirketYetkilisiTC"
                    value={formData.SirketYetkilisiTC}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="TC Kimlik No"
                  />
                  {String(formData.SirketYetkilisiTC || '').trim().length > 0
                    && !tcGecerliMi(formData.SirketYetkilisiTC) && (
                    <span className="tc-uyari">
                      Bu TC kimlik numarası doğrulamadan geçmiyor — kontrol edin.
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Müvekkil bilgileri — föy / türden hemen sonra */}
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin">
                  <span>{isSirket ? 'Şirket / Müvekkil Adı' : 'Müvekkil Adı'} *</span>
                  <label className="bosanma-check-label sirket-inline-check" style={{ margin: 0 }}>
                    <input
                      type="checkbox"
                      name="IsSirket"
                      checked={!!formData.IsSirket}
                      onChange={handleChange}
                    />
                    Şirket
                  </label>
                </span>
                <input
                  type="text"
                  name="Muvekkil"
                  value={formData.Muvekkil}
                  onChange={handleChange}
                  className="form-control"
                  placeholder={isSirket ? 'Şirket Ünvanı' : 'Müvekkil Adı'}
                  required
                />
                {!isBosanmaTuru && !isCezaTuru && (
                  <label className="bosanma-check-label muvekkil-davali-check">
                    <input
                      type="checkbox"
                      name="MuvekkilDavali"
                      checked={!!formData.MuvekkilDavali}
                      onChange={handleChange}
                    />
                    Davalı
                  </label>
                )}
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin">
                  <span>
                  {isSirket ? 'Vergi No' : 'TC'}{' '}
                  {!caseFile && <span style={{ color: 'red' }}>*</span>}
                  </span>
                  {fieldPin('MuvekkilTC')}
                </span>
                <input
                  type="text"
                  name="MuvekkilTC"
                  value={formData.MuvekkilTC}
                  onChange={handleChange}
                  className="form-control"
                  placeholder={isSirket ? 'Vergi No' : 'TC Kimlik No'}
                  required={!caseFile}
                />
                {/* TC'nin son iki hanesi kontrol hanesidir; yanlış yazılan
                    numara doğrulamadan geçmez. Kaydı engellemiyoruz — uyarı
                    veriyoruz, çünkü nadiren de olsa eski kayıtlarda farklı
                    biçimler bulunabiliyor. Şirkette alan vergi numarası
                    tuttuğu için bu kural uygulanmaz. */}
                {!isSirket && String(formData.MuvekkilTC || '').trim().length > 0
                  && !tcGecerliMi(formData.MuvekkilTC) && (
                  <span className="tc-uyari">
                    Bu TC kimlik numarası doğrulamadan geçmiyor — kontrol edin.
                  </span>
                )}
                {!isSirket && tcGecerliMi(formData.MuvekkilTC) && (
                  <span className="tc-tamam">TC doğrulandı</span>
                )}
              </div>
            </div>
          </div>

          {isBosanmaTuru && (
            <div className="form-row bosanma-rol-row">
              <div className="form-column">
                <div className="form-group">
                  <label>Müvekkil Rolü</label>
                  <div className="bosanma-rol-checks">
                    <label className="bosanma-check-label">
                      <input
                        type="checkbox"
                        name="MuvekkilDavaci"
                        checked={!!formData.MuvekkilDavaci}
                        onChange={handleChange}
                      />
                      Davacı
                    </label>
                    <label className="bosanma-check-label">
                      <input
                        type="checkbox"
                        name="MuvekkilDavali"
                        checked={!!formData.MuvekkilDavali}
                        onChange={handleChange}
                      />
                      Davalı
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isCezaTuru && (
            <div className="form-row bosanma-rol-row">
              <div className="form-column" style={{ flex: 1 }}>
                <div className="form-group">
                  <label>Müvekkil Rolü</label>
                  <div className="bosanma-rol-checks ceza-rol-tabs">
                    {[
                      ['MuvekkilSanik', 'Sanık'],
                      ['MuvekkilMusteki', 'Müşteki'],
                      ['MuvekkilSupheli', 'Şüpheli'],
                      ['MuvekkilDavaci', 'Davacı'],
                      ['MuvekkilDavali', 'Davalı'],
                    ].map(([name, label]) => (
                      <label
                        key={name}
                        className={`ceza-rol-tab ${formData[name] ? 'active' : ''}`}
                      >
                        <input
                          type="checkbox"
                          name={name}
                          checked={!!formData[name]}
                          onChange={handleChange}
                        />
                        {label}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="form-row">
            <div className="form-column form-column-full">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Müvekkil Adres</span>{fieldPin('MuvekkilAdres')}</span>
                <input
                  type="text"
                  name="MuvekkilAdres"
                  value={formData.MuvekkilAdres}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Tebligat adresi"
                />
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Müvekkil Telefon{!caseFile ? " *" : ""}</span>{fieldPin('MuvekkilTelefon')}</span>
                <input
                  type="tel"
                  name="MuvekkilTelefon"
                  value={formData.MuvekkilTelefon}
                  onChange={handleChange}
                  onBlur={(e) => {
                    // Numaralar tek biçimde dursun: 05XXXXXXXXX.
                    // Farklı yazımlar arama ve mesaj gönderimini bozuyor.
                    const d = telefonBicimi(e.target.value);
                    if (d && d !== formData.MuvekkilTelefon) {
                      setFormData((prev) => ({ ...prev, MuvekkilTelefon: d }));
                    }
                  }}
                  className="form-control"
                  placeholder="05XX XXX XX XX"
                />
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Müvekkil IBAN</span>{fieldPin('MuvekkilIBAN')}</span>
                <input
                  type="text"
                  name="MuvekkilIBAN"
                  value={formData.MuvekkilIBAN}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Müvekkil IBAN"
                />
              </div>
            </div>
          </div>

          {/* Vekalet + Referans */}
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <label>Vekalet Türü *</label>
                <select
                  name="VekaletTuru"
                  value={formData.VekaletTuru}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="">---------</option>
                  <option value="Süreli">Süreli</option>
                  <option value="Süresiz">Süresiz</option>
                </select>
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <label>Referans *</label>
                <select
                  name="ReferansId"
                  value={formData.ReferansId || ''}
                  onChange={handleChange}
                  className="form-control"
                  required
                  disabled={loadingReferanslar}
                >
                  <option value="">---------</option>
                  {referanslar.map((referans) => {
                    const rid = referans.id ?? referans.Id;
                    const rname = referans.name ?? referans.Name ?? '';
                    return (
                      <option key={rid} value={rid}>
                        {rname}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <label>Aslı Var Mı *</label>
                <div style={{ marginTop: '8px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      name="VekaletinAsliVar"
                      checked={formData.VekaletinAsliVar}
                      onChange={(e) => {
                        setFormData(prev => ({ ...prev, VekaletinAsliVar: e.target.checked }));
                        setHasChanges(true);
                      }}
                      style={{ marginRight: '8px', width: '18px', height: '18px' }}
                    />
                    <span>Evet</span>
                  </label>
                </div>
              </div>
            </div>
            {showVekaletBitisTarihi ? (
            <div className="form-column">
              <div className="form-group">
                <label>Vekaletname Bitiş Tarihi *</label>
                <input
                  type="date"
                  name="VekaletBitisTarihi"
                  value={formData.VekaletBitisTarihi || ''}
                  onChange={(e) => {
                    setFormData(prev => ({ ...prev, VekaletBitisTarihi: e.target.value || '' }));
                    setHasChanges(true);
                  }}
                  className="form-control"
                  placeholder="gg.aa.yyyy"
                  required
                />
              </div>
            </div>
            ) : (
            <div className="form-column" />
            )}
          </div>

          {/* İcra takip bilgisi ekle (otomatik olmayan türler için) */}
          {!requiresIcraTakip(formData.DavaTuru) && parseInt(formData.DavaTuru) > 0 && (
            <div className="form-row-full" style={{ marginTop: '4px' }}>
              <div className="form-group">
                <label className="bosanma-check-label">
                  <input
                    type="checkbox"
                    checked={icraTakipBilgisiEkle}
                    onChange={(e) => setIcraTakipBilgisiEkle(e.target.checked)}
                  />
                  İcra takip bilgisi ekle
                </label>
              </div>
            </div>
          )}

          {/* İcra Takip bilgileri — otomatik türler veya checkbox ile */}
          {showIcraTakipSection() && (
            <div className="icra-form-section">
              <h3 className="icra-section-title">⚖️ İcra Takip Bilgileri</h3>
              {parseInt(formData.DavaTuru) === DAVA_TURU.IcraTaki && (
                <div className="form-row">
                  <div className="form-column">
                    <div className="form-group">
                      <span className="field-label-with-pin"><span>İcra Konusu</span>{fieldPin('IcraKonusu')}</span>
                      <select
                        name="IcraKonusu"
                        value={formData.IcraKonusu || ''}
                        onChange={handleChange}
                        className="form-control"
                      >
                        <option value="">Seçiniz</option>
                        {ICRA_KONUSU_OPTIONS.map((opt) => (
                          <option key={opt} value={opt}>{opt}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-column"></div>
                </div>
              )}
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <label>Takip Açılış (Asıl) Miktarı (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      name="TakipAcilisMiktari"
                      value={formData.TakipAcilisMiktari || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Örn. 100000"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <label>Takip Tarihi</label>
                    <input
                      type="date"
                      name="TakipTarihi"
                      value={formData.TakipTarihi || ''}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <label>Faiz Türü</label>
                    <select
                      name="IcraFaizTuru"
                      value={formData.IcraFaizTuru || 'Yasal'}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="Yasal">Yasal Faiz (dönemsel tablo)</option>
                      <option value="Avans">Avans (Reeskont) Faizi</option>
                      <option value="Sozlesme">Sözleşme (Akdi) Faizi</option>
                    </select>
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <label>Faiz Başlangıç (Temerrüt) Tarihi</label>
                    <input
                      type="date"
                      name="IcraFaizBaslangicTarihi"
                      value={formData.IcraFaizBaslangicTarihi || ''}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
              {(formData.IcraFaizTuru === 'Avans' || formData.IcraFaizTuru === 'Sozlesme') && (
                <div className="form-row">
                  <div className="form-column">
                    <div className="form-group">
                      <label>Yıllık Faiz Oranı (%)</label>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        name="IcraFaizOrani"
                        value={formData.IcraFaizOrani || ''}
                        onChange={handleChange}
                        className="form-control"
                        placeholder={formData.IcraFaizTuru === 'Avans' ? String(getGuncelAvansOrani()) : 'Örn. 55'}
                      />
                      {formData.IcraFaizTuru === 'Avans' && (
                        <small className="icra-hesap-note">
                          TCMB reeskont (iskonto) tablosu dönemsel uygulanır (2026 güncel %{getGuncelAvansOrani()}). İsterseniz oranı değiştirebilirsiniz.
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="form-column"></div>
                </div>
              )}
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <label>Tahsil Harcı Aşaması</label>
                    <select
                      name="IcraTahsilAsamasi"
                      value={formData.IcraTahsilAsamasi || 'once'}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="once">Hacizden önce (%4,55)</option>
                      <option value="sonra">Hacizden sonra (%9,10)</option>
                      <option value="satis">Satış sonrası (%11,38)</option>
                    </select>
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <label>Vekalet Ücreti (elle — boşsa tarifeden hesaplanır)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      name="IcraVekaletUcretiManuel"
                      value={formData.IcraVekaletUcretiManuel || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Otomatik (AAÜT tarifesi)"
                    />
                  </div>
                </div>
              </div>
              <small className="icra-hesap-note">
                Güne göre canlı ayrıntılı hesap için dosyayı kaydettikten sonra <b>Dosya Detay &gt; İcra Hesabı</b> sekmesine bakın.
              </small>

              <div className="form-row" style={{ marginTop: '12px' }}>
                <div className="form-column">
                  <div className="form-group">
                    <label>Takip Türü</label>
                    <div className="bosanma-rol-checks">
                      <label className="bosanma-check-label">
                        <input
                          type="radio"
                          name="IcraIlamsiz"
                          value="true"
                          checked={formData.IcraIlamsiz !== false}
                          onChange={handleChange}
                        />
                        İlamsız
                      </label>
                      <label className="bosanma-check-label">
                        <input
                          type="radio"
                          name="IcraIlamsiz"
                          value="false"
                          checked={formData.IcraIlamsiz === false}
                          onChange={handleChange}
                        />
                        İlamlı
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <label>Borçlu Sayısı</label>
                    <input
                      type="number"
                      min="1"
                      max="30"
                      name="BorcluSayisi"
                      value={formData.BorcluSayisi ?? ''}
                      onChange={handleChange}
                      onBlur={() => {
                        // Alan boş bırakılmışsa mevcut borçlu sayısına döndür.
                        if (formData.BorcluSayisi === '' || formData.BorcluSayisi == null) {
                          setFormData(prev => ({ ...prev, BorcluSayisi: Math.max(1, borclular.length || 1) }));
                        }
                      }}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              <h3 className="bosanma-section-title">Borçlu Bilgileri</h3>
              {borclular.map((b, idx) => (
                <div className="ceza-taraf-block" key={`borclu-${idx}`}>
                  <div className="form-row">
                    <div className="form-column">
                      <div className="form-group">
                        <span className="field-label-with-pin">
                          <span>{b.isSirket ? `Borçlu ${idx + 1} Ünvanı` : `Borçlu ${idx + 1} Adı Soyadı`}</span>
                          <label className="bosanma-check-label sirket-inline-check" style={{ margin: 0 }}>
                            <input
                              type="checkbox"
                              checked={!!b.isSirket}
                              onChange={(e) => updateBorclu(idx, 'isSirket', e.target.checked)}
                            />
                            Şirket
                          </label>
                        </span>
                        <input
                          type="text"
                          value={b.adSoyad || ''}
                          onChange={(e) => updateBorclu(idx, 'adSoyad', e.target.value.toLocaleUpperCase('tr-TR'))}
                          className="form-control"
                          placeholder={b.isSirket ? 'Şirket Ünvanı' : 'Adı Soyadı'}
                        />
                      </div>
                    </div>
                    <div className="form-column">
                      <div className="form-group">
                        <label>{b.isSirket ? `Borçlu ${idx + 1} Vergi No` : `Borçlu ${idx + 1} TC`}</label>
                        <input
                          type="text"
                          value={b.tc || ''}
                          onChange={(e) => updateBorclu(idx, 'tc', e.target.value.toLocaleUpperCase('tr-TR'))}
                          className="form-control"
                          placeholder={b.isSirket ? 'Vergi No' : 'TC Kimlik No'}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Borçlu {idx + 1} Adresi</label>
                    <input
                      type="text"
                      value={b.adres || ''}
                      onChange={(e) => updateBorclu(idx, 'adres', e.target.value.toLocaleUpperCase('tr-TR'))}
                      className="form-control"
                      placeholder="Adres"
                    />
                  </div>
                </div>
              ))}

              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <label>Kesinleşme Tarihi</label>
                    <input
                      type="date"
                      name="KesinlesmeTarihi"
                      value={formData.KesinlesmeTarihi || ''}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="form-column"></div>
              </div>
            </div>
          )}

          {/* Boşanma / Mal Rejimi: Eş → Çocuk → Mali */}
          {isBosanmaTuru && (
            <div className="bosanma-form-section">
              <h3 className="bosanma-section-title">1. Eş Bilgileri</h3>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Eşin Adı Soyadı</span>{fieldPin('EsAdSoyad')}</span>
                    <input
                      type="text"
                      name="EsAdSoyad"
                      value={formData.EsAdSoyad || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Eşin Adı Soyadı"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Eş TC</span>{fieldPin('EsTC')}</span>
                    <input
                      type="text"
                      name="EsTC"
                      value={formData.EsTC || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Eş TC Kimlik No"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <label>Evlilik Tarihi <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="date"
                      name="EvlilikTarihi"
                      value={formData.EvlilikTarihi || ''}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Çalışıyor</span>{fieldPin('EsCalisiyor')}</span>
                    <label className="bosanma-check-label" style={{ marginTop: '10px' }}>
                      <input
                        type="checkbox"
                        name="EsCalisiyor"
                        checked={!!formData.EsCalisiyor}
                        onChange={handleChange}
                      />
                      Eş çalışıyor
                    </label>
                  </div>
                </div>
              </div>

              <h3 className="bosanma-section-title">2. Çocuk Bilgileri</h3>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Çocuk Sayısı</span>{fieldPin('CocukSayisi')}</span>
                    <input
                      type="number"
                      min="0"
                      max="20"
                      name="CocukSayisi"
                      value={formData.CocukSayisi === '' || formData.CocukSayisi == null ? '' : formData.CocukSayisi}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="0"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Velayet Talebi</span>{fieldPin('VelayetTalebi')}</span>
                    <label className="bosanma-check-label" style={{ marginTop: '10px' }}>
                      <input
                        type="checkbox"
                        name="VelayetTalebi"
                        checked={!!formData.VelayetTalebi}
                        onChange={handleChange}
                      />
                      Velayet talebi var
                    </label>
                  </div>
                </div>
              </div>
              {cocuklar.map((c, idx) => {
                const childRequired = !!(formData.Muvekkil || '').trim() && !!(formData.MuvekkilTC || '').trim();
                return (
                  <div className="form-row" key={`cocuk-${idx}`}>
                    <div className="form-column">
                      <div className="form-group">
                        <label>Çocuk {idx + 1} Adı {childRequired && <span style={{ color: 'red' }}>*</span>}</label>
                        <input
                          type="text"
                          value={c.adSoyad || ''}
                          onChange={(e) => updateCocuk(idx, 'adSoyad', e.target.value.toLocaleUpperCase('tr-TR'))}
                          className="form-control"
                          placeholder={`Çocuk ${idx + 1} Adı Soyadı`}
                          required={childRequired}
                        />
                      </div>
                    </div>
                    <div className="form-column">
                      <div className="form-group">
                        <label>Çocuk {idx + 1} Doğum Tarihi {childRequired && <span style={{ color: 'red' }}>*</span>}</label>
                        <input
                          type="date"
                          value={c.dogumTarihi || ''}
                          onChange={(e) => updateCocuk(idx, 'dogumTarihi', e.target.value)}
                          className="form-control"
                          required={childRequired}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}

              <h3 className="bosanma-section-title">3. Mali Talepler</h3>
              <div className="bosanma-mali-talepler">
                {[
                  ['TalepNafaka', 'Nafaka Talebi'],
                  ['TalepTedbirNafaka', 'Tedbir Nafakası'],
                  ['TalepIstirakNafaka', 'İştirak Nafakası'],
                  ['TalepYoksullukNafaka', 'Yoksulluk Nafakası'],
                  ['TalepMaddiTazminat', 'Maddi Tazminat'],
                  ['TalepManeviTazminat', 'Manevi Tazminat'],
                ].map(([name, label]) => (
                  <label key={name} className="bosanma-check-label">
                    <input
                      type="checkbox"
                      name={name}
                      checked={!!formData[name]}
                      onChange={handleChange}
                    />
                    {label}
                  </label>
                ))}
              </div>
            </div>
          )}

          {/* Ceza / Soruşturma özel alanlar */}
          {isCezaTuru && (
            <div className="bosanma-form-section ceza-form-section">
              <h3 className="bosanma-section-title">Suç Bilgisi</h3>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Suç Türü</span>{fieldPin('SucTuru')}</span>
                    <input
                      type="text"
                      name="SucTuru"
                      value={formData.SucTuru || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Suç Türü"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Suç Tarihi</span>{fieldPin('SucTarihi')}</span>
                    <input
                      type="date"
                      name="SucTarihi"
                      value={formData.SucTarihi || ''}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Suç Yeri</span>{fieldPin('SucYeri')}</span>
                    <input
                      type="text"
                      name="SucYeri"
                      value={formData.SucYeri || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Suç Yeri"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>TCK Maddesi</span>{fieldPin('TckMaddesi')}</span>
                    <input
                      type="text"
                      name="TckMaddesi"
                      value={formData.TckMaddesi || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="TCK Maddesi"
                    />
                  </div>
                </div>
              </div>

              <h3 className="bosanma-section-title">Taraflar</h3>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Taraf Sayısı</span>{fieldPin('TarafSayisi')}</span>
                    <input
                      type="number"
                      min="0"
                      max="30"
                      name="TarafSayisi"
                      value={formData.TarafSayisi === '' || formData.TarafSayisi == null ? '' : formData.TarafSayisi}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="0"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Savcılık Soruşturma Numarası</span>{fieldPin('SavcilikCezaDosyaNo')}</span>
                    <input
                      type="text"
                      name="SavcilikCezaDosyaNo"
                      value={formData.SavcilikCezaDosyaNo || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Savcılık Soruşturma Numarası"
                    />
                  </div>
                </div>
              </div>

              {taraflar.map((t, idx) => (
                <div className="ceza-taraf-block" key={`taraf-${idx}`}>
                  <div className="form-row">
                    <div className="form-column">
                      <div className="form-group">
                        <label>Taraf {idx + 1} Adı Soyadı</label>
                        <input
                          type="text"
                          value={t.adSoyad || ''}
                          onChange={(e) => updateTaraf(idx, 'adSoyad', e.target.value.toLocaleUpperCase('tr-TR'))}
                          className="form-control"
                          placeholder={`Taraf ${idx + 1} Adı Soyadı`}
                        />
                      </div>
                    </div>
                    <div className="form-column">
                      <div className="form-group">
                        <label>Taraf {idx + 1} TC</label>
                        <input
                          type="text"
                          value={t.tc || ''}
                          onChange={(e) => updateTaraf(idx, 'tc', e.target.value.toLocaleUpperCase('tr-TR'))}
                          className="form-control"
                          placeholder="TC Kimlik No"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Taraf {idx + 1} Rolü</label>
                    <div className="bosanma-rol-checks ceza-rol-tabs">
                      {CEZA_TARAF_ROLLERI.map((rol) => (
                        <label
                          key={rol}
                          className={`ceza-rol-tab ${(t.rol || '') === rol ? 'active' : ''}`}
                        >
                          <input
                            type="radio"
                            name={`taraf-rol-${idx}`}
                            checked={(t.rol || '') === rol}
                            onChange={() => updateTaraf(idx, 'rol', rol)}
                          />
                          {rol}
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              ))}

              <h3 className="bosanma-section-title">Tedbirler</h3>
              <div className="bosanma-rol-checks ceza-rol-tabs">
                {[
                  ['TedbirTutuklu', 'Tutuklu'],
                  ['TedbirAdliKontrol', 'Adli Kontrol'],
                  ['TedbirYakalamaKarari', 'Yakalama Kararı'],
                ].map(([name, label]) => (
                  <label
                    key={name}
                    className={`ceza-rol-tab ${formData[name] ? 'active' : ''}`}
                  >
                    <input
                      type="checkbox"
                      name={name}
                      checked={!!formData[name]}
                      onChange={handleChange}
                    />
                    {label}
                  </label>
                ))}
              </div>

              <div className="form-row" style={{ marginTop: '14px' }}>
                <div className="form-column">
                  <div className="form-group">
                    <label className="bosanma-check-label">
                      <input
                        type="checkbox"
                        name="KovusturmayaYerOlmadigiKarari"
                        checked={!!formData.KovusturmayaYerOlmadigiKarari}
                        onChange={handleChange}
                      />
                      Kovuşturmaya Yer Olmadığı Kararı
                    </label>
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>İddianame Tarihi</span>{fieldPin('IddianameTarihi')}</span>
                    <input
                      type="date"
                      name="IddianameTarihi"
                      value={formData.IddianameTarihi || ''}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Araç hasar ve değer kaybı hesabı (trafik / hasar / değer kaybı dosyaları) */}
          {isAracHasarTuru && (
            <div className="iscilik-hesap-alani">
              {!aracHesapAcik ? (
                <button type="button" className="iscilik-hesap-ac" onClick={() => setAracHesapAcik(true)}>
                  Hasar ve Değer Kaybı Hesapla
                </button>
              ) : (
                <AracHasarHesap
                  embedded
                  onKapat={() => setAracHesapAcik(false)}
                  caseFile={{
                    Id: caseFile?.Id ?? caseFile?.id,
                    FoyNo: formData.FoyNo,
                    Muvekkil: formData.Muvekkil,
                    MuvekkilPlaka: formData.MuvekkilPlaka,
                    KazaTarihi: formData.KazaTarihi,
                    KarsiTarafSigortaSirketi: formData.KarsiTarafSigortaSirketi,
                    SigortaBasvuruTarihi: formData.SigortaBasvuruTarihi,
                  }}
                />
              )}
            </div>
          )}

          {/* İşçilik Alacakları özel alanlar */}
          {isIscilikTuru && (
            <div className="bosanma-form-section iscilik-form-section">
              <h3 className="bosanma-section-title">İş Bilgileri</h3>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>İşveren / Firma</span>{fieldPin('IsverenFirma')}</span>
                    <input
                      type="text"
                      name="IsverenFirma"
                      value={formData.IsverenFirma || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="İşveren / Firma"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>T.C / VKN</span>{fieldPin('IsverenTcvkn')}</span>
                    <input
                      type="text"
                      name="IsverenTcvkn"
                      value={formData.IsverenTcvkn || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="T.C / VKN"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Yetkili</span>{fieldPin('IsverenYetkilisi')}</span>
                    <input
                      type="text"
                      name="IsverenYetkilisi"
                      value={formData.IsverenYetkilisi || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Yetkili adı"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Adres</span>{fieldPin('IsverenAdresi')}</span>
                    <input
                      type="text"
                      name="IsverenAdresi"
                      value={formData.IsverenAdresi || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Tebligat adresi"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>SGK Sicil No</span>{fieldPin('SgkSicilNo')}</span>
                    <input
                      type="text"
                      name="SgkSicilNo"
                      value={formData.SgkSicilNo || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="SGK Sicil No"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>İşe Giriş Tarihi</span>{fieldPin('IseGirisTarihi')}</span>
                    <input
                      type="date"
                      name="IseGirisTarihi"
                      value={formData.IseGirisTarihi || ''}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>İşten Çıkış Tarihi</span>{fieldPin('IstenCikisTarihi')}</span>
                    <input
                      type="date"
                      name="IstenCikisTarihi"
                      value={formData.IstenCikisTarihi || ''}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Çıkış Nedeni</span>{fieldPin('CikisNedeni')}</span>
                    <input
                      type="text"
                      name="CikisNedeni"
                      value={formData.CikisNedeni || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Çıkış Nedeni"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Son Ücret</span>{fieldPin('SonUcret')}</span>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      name="SonUcret"
                      value={formData.SonUcret === '' || formData.SonUcret == null ? '' : formData.SonUcret}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Son Ücret"
                    />
                  </div>
                </div>
              </div>

              <h3 className="bosanma-section-title">Talepler</h3>
              <div className="bosanma-mali-talepler">
                {[
                  ['TalepKidem', 'Kıdem'],
                  ['TalepIhbar', 'İhbar'],
                  ['TalepFazlaMesai', 'Fazla Mesai'],
                  ['TalepUbgt', 'UBGT'],
                  ['TalepHaftaTatili', 'Hafta Tatili'],
                  ['TalepYillikIzin', 'Yıllık İzin'],
                  ['TalepAgi', 'AGİ'],
                  ['TalepMaasAlacagi', 'Maaş Alacağı'],
                ].map(([name, label]) => (
                  <label key={name} className="bosanma-check-label">
                    <input
                      type="checkbox"
                      name={name}
                      checked={!!formData[name]}
                      onChange={handleChange}
                    />
                    {label}
                  </label>
                ))}
              </div>

              <h3 className="bosanma-section-title">Süreç</h3>
              {/* Arabuluculuk başvuru ve son tutanak tarihleri aşağıdaki
                  ortak "Arabuluculuk" bloğunda (2026-10-07). */}
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Dava Tarihi</span>{fieldPin('IscilikDavaTarihi')}</span>
                    <input
                      type="date"
                      name="IscilikDavaTarihi"
                      value={formData.IscilikDavaTarihi || ''}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Bilirkişi Tarihi</span>{fieldPin('BilirkisiTarihi')}</span>
                    <input
                      type="date"
                      name="BilirkisiTarihi"
                      value={formData.BilirkisiTarihi || ''}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Islah Tarihi</span>{fieldPin('IslahTarihi')}</span>
                    <input
                      type="date"
                      name="IslahTarihi"
                      value={formData.IslahTarihi || ''}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              {/* Açılır işçilik alacağı hesabı — form alanlarından beslenir,
                  sonucu PDF olarak dosyanın belgelerine yükleyebilir. */}
              <div className="iscilik-hesap-alani">
                {!iscilikHesapAcik ? (
                  <button
                    type="button"
                    className="iscilik-hesap-ac"
                    onClick={() => setIscilikHesapAcik(true)}
                  >
                    İşçilik Alacağı Hesapla
                  </button>
                ) : (
                  <IscilikHesap
                    embedded
                    onKapat={() => setIscilikHesapAcik(false)}
                    caseFile={{
                      Id: caseFile?.Id ?? caseFile?.id,
                      FoyNo: formData.FoyNo,
                      Muvekkil: formData.Muvekkil,
                      IsverenFirma: formData.IsverenFirma,
                      SonUcret: formData.SonUcret,
                      IseGirisTarihi: formData.IseGirisTarihi,
                      IstenCikisTarihi: formData.IstenCikisTarihi,
                    }}
                  />
                )}
              </div>
            </div>
          )}

          {/* İş kazasında karşı taraf işverendir */}
          {isIsKazasiTuru && (
            <div className="bosanma-form-section iscilik-form-section">
              <h3 className="bosanma-section-title">Karşı Şirket Bilgileri</h3>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>İşveren / Şirket</span>{fieldPin('IsverenFirma')}</span>
                    <input
                      type="text"
                      name="IsverenFirma"
                      value={formData.IsverenFirma || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="İşveren / Şirket"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>T.C / VKN</span>{fieldPin('IsverenTcvkn')}</span>
                    <input
                      type="text"
                      name="IsverenTcvkn"
                      value={formData.IsverenTcvkn || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="T.C / VKN"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Yetkili</span>{fieldPin('IsverenYetkilisi')}</span>
                    <input
                      type="text"
                      name="IsverenYetkilisi"
                      value={formData.IsverenYetkilisi || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Yetkili adı"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>Adres</span>{fieldPin('IsverenAdresi')}</span>
                    <input
                      type="text"
                      name="IsverenAdresi"
                      value={formData.IsverenAdresi || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Tebligat adresi"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>SGK Sicil No</span>{fieldPin('SgkSicilNo')}</span>
                    <input
                      type="text"
                      name="SgkSicilNo"
                      value={formData.SgkSicilNo || ''}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="SGK Sicil No"
                    />
                  </div>
                </div>
                <div className="form-column">
                  <div className="form-group">
                    <span className="field-label-with-pin"><span>İşe Giriş Tarihi</span>{fieldPin('IseGirisTarihi')}</span>
                    <input
                      type="date"
                      name="IseGirisTarihi"
                      value={formData.IseGirisTarihi || ''}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Grup 5–8: Kaza / plaka / sigorta / karşı taraf — boşanma & cezada gizlenir */}
          {showTrafficFields && (
          <>
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin">
                  <span>
                  Kaza Tarihi {requiresVehicleFields() && <span style={{ color: 'red' }}>*</span>}
                  </span>
                  {fieldPin('KazaTarihi')}
                </span>
                <input
                  type="date"
                  name="KazaTarihi"
                  value={formData.KazaTarihi || ''}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="mm/dd/yyyy"
                  required={requiresVehicleFields()}
                />
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin">
                  <span>
                  Kaza Şehri {requiresVehicleFields() && <span style={{ color: 'red' }}>*</span>}
                  </span>
                  {fieldPin('KazaSehri')}
                </span>
                <select
                  name="KazaSehri"
                  value={formData.KazaSehri}
                  onChange={handleChange}
                  className="form-control"
                  required={requiresVehicleFields()}
                >
                  {turkiyeIlleri.map((il, index) => (
                    <option key={index} value={il || ''}>
                      {il || '------'}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Grup 6: Müvekkil plaka - Müvekkil araç sigorta şirketi (dosya türüne göre zorunlu) */}
          <div
            className="form-row-full"
            style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px 18px', marginBottom: '6px' }}
          >
            <label className="bosanma-check-label" style={{ margin: 0 }}>
              <input
                type="checkbox"
                checked={formData.MuvekkilAracRolu === 'Yolcu'}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    MuvekkilAracRolu: e.target.checked ? 'Yolcu' : ''
                  }));
                  setHasChanges(true);
                }}
              />
              Yolcu
            </label>
            <label className="bosanma-check-label" style={{ margin: 0 }}>
              <input
                type="checkbox"
                checked={formData.MuvekkilAracRolu === 'Yaya'}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    MuvekkilAracRolu: e.target.checked ? 'Yaya' : ''
                  }));
                  setHasChanges(true);
                }}
              />
              Yaya
            </label>
          </div>
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin">
                  <span>
                  Müvekkil Plaka {(formData.MuvekkilAracRolu === 'Yolcu' || (requiresVehicleFields() && formData.MuvekkilAracRolu !== 'Yaya')) && <span style={{ color: 'red' }}>*</span>}
                  </span>
                  {fieldPin('MuvekkilPlaka')}
                </span>
                <input
                  type="text"
                  name="MuvekkilPlaka"
                  value={formData.MuvekkilPlaka}
                  onChange={handleChange}
                  className="form-control"
                  placeholder={formData.MuvekkilAracRolu === 'Yaya' ? 'Yaya — plaka zorunlu değil' : 'Müvekkil Plaka'}
                  required={formData.MuvekkilAracRolu === 'Yolcu' || (requiresVehicleFields() && formData.MuvekkilAracRolu !== 'Yaya')}
                />
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin">
                  <span>
                  Müvekkil Araç Sigorta Şirketi {requiresVehicleFields() && formData.MuvekkilAracRolu !== 'Yaya' && <span style={{ color: 'red' }}>*</span>}
                  </span>
                  {fieldPin('MuvekkilAracSigortaSirketi')}
                </span>
                <>
                  <select
                    name="MuvekkilAracSigortaSirketi"
                    value={showOtherMuvekkilSigorta || (!sigortaSirketleri.includes(formData.MuvekkilAracSigortaSirketi) && formData.MuvekkilAracSigortaSirketi) ? 'Diğer' : (formData.MuvekkilAracSigortaSirketi || '')}
                    onChange={(e) => {
                      if (e.target.value === 'Diğer') {
                        setShowOtherMuvekkilSigorta(true);
                        setFormData(prev => ({
                          ...prev,
                          MuvekkilAracSigortaSirketi: ''
                        }));
                      } else {
                        setShowOtherMuvekkilSigorta(false);
                        setFormData(prev => ({
                          ...prev,
                          MuvekkilAracSigortaSirketi: e.target.value.toLocaleUpperCase('tr-TR')
                        }));
                      }
                    }}
                    className="form-control"
                    required={requiresVehicleFields() && formData.MuvekkilAracRolu !== 'Yaya'}
                  >
                    <option value="">------</option>
                    {sigortaSirketleri.map((sirket, index) => (
                      <option key={index} value={sirket}>
                        {sirket}
                      </option>
                    ))}
                    <option value="Diğer">Diğer</option>
                  </select>
                  {(showOtherMuvekkilSigorta || (!sigortaSirketleri.includes(formData.MuvekkilAracSigortaSirketi) && formData.MuvekkilAracSigortaSirketi)) && (
                    <input
                      type="text"
                      name="MuvekkilAracSigortaSirketi"
                      value={formData.MuvekkilAracSigortaSirketi}
                      onChange={(e) => {
                        setFormData(prev => ({
                          ...prev,
                          MuvekkilAracSigortaSirketi: e.target.value
                        }));
                      }}
                      className="form-control"
                      style={{ marginTop: '8px' }}
                      placeholder="Diğer sigorta şirketi adını girin"
                      required={requiresVehicleFields() && formData.MuvekkilAracRolu !== 'Yaya'}
                    />
                  )}
                </>
              </div>
            </div>
          </div>

          {/* Grup 7: Karşı taraf araç plaka - Karşı taraf sigorta şirketi (dosya türüne göre zorunlu) */}
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin">
                  <span>
                  Karşı Taraf Plaka {requiresVehicleFields() && <span style={{ color: 'red' }}>*</span>}
                  </span>
                  {fieldPin('KarsiTarafPlaka')}
                </span>
                <input
                  type="text"
                  name="KarsiTarafPlaka"
                  value={formData.KarsiTarafPlaka}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Karşı Taraf Plaka"
                  required={requiresVehicleFields()}
                />
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin">
                  <span>
                  Karşı Taraf Sigorta Şirketi {requiresVehicleFields() && <span style={{ color: 'red' }}>*</span>}
                  </span>
                  {fieldPin('KarsiTarafSigortaSirketi')}
                </span>
                <>
                  <select
                    name="KarsiTarafSigortaSirketi"
                    value={showOtherSigorta || (!sigortaSirketleri.includes(formData.KarsiTarafSigortaSirketi) && formData.KarsiTarafSigortaSirketi) ? 'Diğer' : (formData.KarsiTarafSigortaSirketi || '')}
                    onChange={(e) => {
                      if (e.target.value === 'Diğer') {
                        setShowOtherSigorta(true);
                        setFormData(prev => ({
                          ...prev,
                          KarsiTarafSigortaSirketi: ''
                        }));
                      } else {
                        setShowOtherSigorta(false);
                        setFormData(prev => ({
                          ...prev,
                          KarsiTarafSigortaSirketi: e.target.value.toLocaleUpperCase('tr-TR')
                        }));
                      }
                    }}
                    className="form-control"
                    required={requiresVehicleFields()}
                  >
                    <option value="">------</option>
                    {sigortaSirketleri.map((sirket, index) => (
                      <option key={index} value={sirket}>
                        {sirket}
                      </option>
                    ))}
                    <option value="Diğer">Diğer</option>
                  </select>
                  {(showOtherSigorta || (!sigortaSirketleri.includes(formData.KarsiTarafSigortaSirketi) && formData.KarsiTarafSigortaSirketi)) && (
                    <input
                      type="text"
                      name="KarsiTarafSigortaSirketi"
                      value={formData.KarsiTarafSigortaSirketi}
                      onChange={(e) => {
                        setFormData(prev => ({
                          ...prev,
                          KarsiTarafSigortaSirketi: e.target.value
                        }));
                      }}
                      className="form-control"
                      style={{ marginTop: '8px' }}
                      placeholder="Diğer sigorta şirketi adını girin"
                      required={requiresVehicleFields()}
                    />
                  )}
                </>
              </div>
            </div>
          </div>

          {/* Grup 8: Karşı taraf1 - Karşı taraf2
              İcra dosyalarında karşı taraf zaten "Borçlu Bilgileri" bölümünde
              ad, TC ve adresiyle giriliyor; aynı kişiyi iki yere yazmamak için
              bu blok gizleniyor. Daha önce doldurulmuş bir değer varsa
              gizlemiyoruz — yoksa girilmiş bilgi görünmez olurdu. */}
          {(!requiresIcraTakip(formData.DavaTuru) || formData.KarsiTaraf1 || formData.KarsiTaraf2) && (
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Karşı Taraf1</span>{fieldPin('KarsiTaraf1')}</span>
                <input
                  type="text"
                  name="KarsiTaraf1"
                  value={formData.KarsiTaraf1}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Karşı Taraf1"
                />
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Karşı Taraf2</span>{fieldPin('KarsiTaraf2')}</span>
                <input
                  type="text"
                  name="KarsiTaraf2"
                  value={formData.KarsiTaraf2}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Karşı Taraf2"
                />
              </div>
            </div>
          </div>
          )}
          </>
          )}

          {/* Grup 9: Dosya geliş tarihi - Zaman aşımı tarihi */}
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <label>Dosya Geliş Tarihi *</label>
                <input
                  type="date"
                  name="DosyaGelisTarihi"
                  value={formData.DosyaGelisTarihi || ''}
                  onChange={(e) => {
                    setFormData(prev => ({ ...prev, DosyaGelisTarihi: e.target.value || '' }));
                  }}
                  className="form-control"
                  placeholder="mm/dd/yyyy"
                  required
                />
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin">
                  <span>
                  Zaman Aşımı Tarihi {requiresVehicleFields() && <span style={{ color: 'red' }}>*</span>}
                  </span>
                  {fieldPin('ZamanAsimiTarihi')}
                </span>
                <input
                  type="date"
                  name="ZamanAsimiTarihi"
                  value={formData.ZamanAsimiTarihi || ''}
                  onChange={(e) => {
                    setFormData(prev => ({ ...prev, ZamanAsimiTarihi: e.target.value || '' }));
                  }}
                  className="form-control"
                  placeholder="mm/dd/yyyy"
                  required={requiresVehicleFields()}
                />
              </div>
            </div>
          </div>

          {/* Grup 10: Sözleşme oran (Referans vekalet bölümüne taşındı) */}
          {showTrafficFields && (
          <div className="form-row-full">
            <div className="form-group">
              <span className="field-label-with-pin"><span>Sözleşme Oran</span>{fieldPin('SozlesmeOrani')}</span>
              <div className="sozlesme-oran-row">
                <input
                  type="number"
                  name="SozlesmeOrani"
                  value={formData.SozlesmeOrani}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Sözleşme Oran"
                  step="0.01"
                  min="0"
                  max="100"
                />
                <label className="sozlesme-kdv-check">
                  <input
                    type="checkbox"
                    name="SozlesmeOraniKdvDahil"
                    checked={!!formData.SozlesmeOraniKdvDahil}
                    onChange={handleChange}
                  />
                  <span>KDV dahil</span>
                </label>
              </div>
            </div>
          </div>
          )}

          {/* Grup 11: Tahkim başvuru tarihi (boşanmada gizli) - Duruşma tarihi */}
          <div className="form-row">
            {showTrafficFields && (
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Tahkim Başvuru Tarihi</span>{fieldPin('TahkimBasvuruTarihi')}</span>
                <input
                  type="date"
                  name="TahkimBasvuruTarihi"
                  value={formData.TahkimBasvuruTarihi || ''}
                  onChange={(e) => {
                    setFormData(prev => ({ ...prev, TahkimBasvuruTarihi: e.target.value || '' }));
                  }}
                  className="form-control"
                  placeholder="mm/dd/yyyy"
                />
              </div>
            </div>
            )}
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Duruşma Tarihi ve Saati</span>{fieldPin('DurusmaTarihi')}</span>
                <div className="datetime-picker-24h">
                  <input
                    type="date"
                    name="DurusmaTarihiDate"
                    value={formData.DurusmaTarihi ? formData.DurusmaTarihi.split('T')[0] : ''}
                    onChange={(e) => {
                      const datePart = e.target.value || '';
                      const timePart = formData.DurusmaTarihi && formData.DurusmaTarihi.includes('T') 
                        ? formData.DurusmaTarihi.split('T')[1].substring(0, 5)
                        : '09:00';
                      setFormData(prev => ({ 
                        ...prev, 
                        DurusmaTarihi: datePart ? `${datePart}T${timePart}` : '' 
                      }));
                    }}
                    className="form-control"
                  />
                  <select
                    name="DurusmaTarihiHour"
                    value={formData.DurusmaTarihi && formData.DurusmaTarihi.includes('T') 
                      ? formData.DurusmaTarihi.split('T')[1].split(':')[0] 
                      : '09'}
                    onChange={(e) => {
                      const datePart = formData.DurusmaTarihi ? formData.DurusmaTarihi.split('T')[0] : '';
                      const timePart = formData.DurusmaTarihi && formData.DurusmaTarihi.includes('T') 
                        ? formData.DurusmaTarihi.split('T')[1].substring(0, 5)
                        : '09:00';
                      const minutePart = timePart.split(':')[1] || '00';
                      const hour = e.target.value;
                      setFormData(prev => ({ 
                        ...prev, 
                        DurusmaTarihi: datePart ? `${datePart}T${hour.padStart(2, '0')}:${minutePart.padStart(2, '0')}` : '' 
                      }));
                    }}
                    className="form-control datetime-time-select"
                    disabled={!formData.DurusmaTarihi || !formData.DurusmaTarihi.includes('T')}
                  >
                    {Array.from({ length: 24 }, (_, i) => (
                      <option key={i} value={String(i).padStart(2, '0')}>
                        {String(i).padStart(2, '0')}
                      </option>
                    ))}
                  </select>
                  <span className="datetime-separator">:</span>
                  <select
                    name="DurusmaTarihiMinute"
                    value={formData.DurusmaTarihi && formData.DurusmaTarihi.includes('T') 
                      ? (formData.DurusmaTarihi.split('T')[1].split(':')[1] || '00').substring(0, 2)
                      : '00'}
                    onChange={(e) => {
                      const datePart = formData.DurusmaTarihi ? formData.DurusmaTarihi.split('T')[0] : '';
                      const timePart = formData.DurusmaTarihi && formData.DurusmaTarihi.includes('T') 
                        ? formData.DurusmaTarihi.split('T')[1].substring(0, 5)
                        : '09:00';
                      const hourPart = timePart.split(':')[0] || '09';
                      const minute = e.target.value;
                      setFormData(prev => ({ 
                        ...prev, 
                        DurusmaTarihi: datePart ? `${datePart}T${hourPart}:${minute.padStart(2, '0')}` : '' 
                      }));
                    }}
                    className="form-control datetime-time-select"
                    disabled={!formData.DurusmaTarihi || !formData.DurusmaTarihi.includes('T')}
                  >
                    {Array.from({ length: 60 }, (_, i) => (
                      <option key={i} value={String(i).padStart(2, '0')}>
                        {String(i).padStart(2, '0')}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Grup 12: Sigorta başvuru tarihi (boşanmada gizli) - Dava açılış tarihi */}
          <div className="form-row">
            {showTrafficFields && (
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Sigorta Başvuru Tarihi</span>{fieldPin('SigortaBasvuruTarihi')}</span>
                <input
                  type="date"
                  name="SigortaBasvuruTarihi"
                  value={formData.SigortaBasvuruTarihi || ''}
                  onChange={(e) => {
                    setFormData(prev => ({ ...prev, SigortaBasvuruTarihi: e.target.value || '' }));
                  }}
                  className="form-control"
                  placeholder="mm/dd/yyyy"
                />
              </div>
            </div>
            )}
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Dava Açılış Tarihi</span>{fieldPin('DavaAcilisTarihi')}</span>
                <input
                  type="date"
                  name="DavaAcilisTarihi"
                  value={formData.DavaAcilisTarihi || ''}
                  onChange={(e) => {
                    setFormData(prev => ({ ...prev, DavaAcilisTarihi: e.target.value || '' }));
                  }}
                  className="form-control"
                  placeholder="mm/dd/yyyy"
                />
              </div>
            </div>
          </div>

          {/* Grup 13: Tahkim başvuru no - İtiraz başvuru no (boşanmada gizli) */}
          {showTrafficFields && (
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Tahkim Başvuru No</span>{fieldPin('TahkimBasvuruNo')}</span>
                <input
                  type="text"
                  name="TahkimBasvuruNo"
                  value={formData.TahkimBasvuruNo}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Tahkim Başvuru No"
                />
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>İtiraz Başvuru No</span>{fieldPin('ItirazBasvuruNo')}</span>
                <input
                  type="text"
                  name="ItirazBasvuruNo"
                  value={formData.ItirazBasvuruNo}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="İtiraz Başvuru No"
                />
              </div>
            </div>
          </div>
          )}

          {/* Grup 14: Mahkeme bilgisi - Mahkeme esas */}
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Mahkeme Bilgisi</span>{fieldPin('MahkemaBilgisi')}</span>
                <textarea
                  name="MahkemaBilgisi"
                  value={formData.MahkemaBilgisi}
                  onChange={handleChange}
                  className="form-control"
                  rows="3"
                  placeholder="Mahkeme Bilgisi"
                />
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Mahkeme Esas</span>{fieldPin('MahkemeEsas')}</span>
                <input
                  type="text"
                  name="MahkemeEsas"
                  value={formData.MahkemeEsas}
                  onChange={handleChange}
                  className="form-control"
                  placeholder={
                    formData.IcraDosyaNo || formData.TahkimBasvuruNo || 'Mahkeme Esas'
                  }
                />
              </div>
            </div>
          </div>

          {isBosanmaTuru && (
          <div className="form-row-full">
            <div className="form-group">
              <span className="field-label-with-pin"><span>Boşanma Sebebi</span>{fieldPin('BosanmaSebebi')}</span>
              <textarea
                name="BosanmaSebebi"
                value={formData.BosanmaSebebi || ''}
                onChange={handleChange}
                className="form-control"
                rows="2"
                placeholder="Boşanma sebebini yazınız"
              />
            </div>
          </div>
          )}

          {/* Grup 15–16: Savcılık/İcra/Rapor (boşanmada gizli) */}
          {showTrafficFields && (
          <>
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Savcılık/Ceza Dosya No</span>{fieldPin('SavcilikCezaDosyaNo')}</span>
                <input
                  type="text"
                  name="SavcilikCezaDosyaNo"
                  value={formData.SavcilikCezaDosyaNo}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Savcılık/Ceza Dosya No"
                />
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>İcra Dosya No</span>{fieldPin('IcraDosyaNo')}</span>
                <input
                  type="text"
                  name="IcraDosyaNo"
                  value={formData.IcraDosyaNo}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="İcra Dosya No"
                />
              </div>
            </div>
          </div>

          <div className="form-row-full">
            <div className="form-group">
              <span className="field-label-with-pin">
                <span>Rapor Tarihi{requiresAutoRaporTarihi1Yil(formData.DavaTuru) ? ' (kaza + 1 yıl)' : ''}</span>
                {fieldPin('RaporTarihi')}
              </span>
              <input
                type="date"
                name="RaporTarihi"
                value={formData.RaporTarihi || ''}
                onChange={(e) => {
                  if (requiresAutoRaporTarihi1Yil(formData.DavaTuru)) return;
                  setFormData(prev => ({ ...prev, RaporTarihi: e.target.value || '' }));
                }}
                className="form-control"
                readOnly={requiresAutoRaporTarihi1Yil(formData.DavaTuru)}
                title={requiresAutoRaporTarihi1Yil(formData.DavaTuru) ? 'Trafik Kazası Maluliyet dosyalarında rapor tarihi kaza tarihinden 1 yıl sonradır' : undefined}
                placeholder="mm/dd/yyyy"
              />
            </div>
          </div>
          </>
          )}

          {/* Grup 17: Ödeme bilgileri */}
          <div className="form-row-full" style={{ marginTop: '8px' }}>
            <div className="form-group">
              <label className="bosanma-check-label">
                <input
                  type="checkbox"
                  name="OdemeBilgileriGoster"
                  checked={!!formData.OdemeBilgileriGoster}
                  onChange={handleChange}
                />
                Ödeme bilgilerini dosya detayında göster
              </label>
            </div>
          </div>
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Gelen Ödeme Durumu</span>{fieldPin('GelenOdemeDurumu')}</span>
                <select
                  name="GelenOdemeDurumu"
                  value={formData.GelenOdemeDurumu}
                  onChange={handleChange}
                  className="form-control"
                >
                  {gelenOdemeDurumlari.map((durum, index) => (
                    <option key={index} value={durum || ''}>
                      {durum || '------'}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Giden Ödeme Durumu</span>{fieldPin('GidenOdemeDurumu')}</span>
                <select
                  name="GidenOdemeDurumu"
                  value={formData.GidenOdemeDurumu}
                  onChange={handleChange}
                  className="form-control"
                >
                  {gidenOdemeDurumlari.map((durum, index) => (
                    <option key={index} value={durum || ''}>
                      {durum || '------'}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Grup 18: İbra aşaması - SMM */}
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>İbra Aşaması</span>{fieldPin('IbraAsamasi')}</span>
                <select
                  name="IbraAsamasi"
                  value={formData.IbraAsamasi}
                  onChange={handleChange}
                  className="form-control"
                >
                  {ibraAsamalari.map((asama, index) => (
                    <option key={index} value={asama || ''}>
                      {asama || '------'}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>SMM</span>{fieldPin('SMM')}</span>
                <select
                  name="SMM"
                  value={formData.SMM}
                  onChange={handleChange}
                  className="form-control"
                >
                  {smmDurumlari.map((durum, index) => (
                    <option key={index} value={durum || ''}>
                      {durum || '------'}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Grup 19: Sulh (boşanmada gizli) - Karşı vekil */}
          <div className="form-row">
            {showTrafficFields && (
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin"><span>Sulh Durumu</span>{fieldPin('SulhDurumu')}</span>
                <select
                  name="SulhDurumu"
                  value={formData.SulhDurumu}
                  onChange={handleChange}
                  className="form-control"
                >
                  {sulhDurumlari.map((durum, index) => (
                    <option key={index} value={durum || ''}>
                      {durum || '------'}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            )}
            <div className="form-column">
              <div className="form-group">
                <span className="field-label-with-pin">
                  <span>{(isBosanmaTuru || isCezaTuru || isIscilikTuru) ? 'Karşı Vekil Bilgileri' : 'Karşı Taraf Sigorta Şirketi Vekili'}</span>
                  {fieldPin('KarsiTarafSigortaSirketiVekili')}
                </span>
                <input
                  type="text"
                  name="KarsiTarafSigortaSirketiVekili"
                  value={formData.KarsiTarafSigortaSirketiVekili}
                  onChange={handleChange}
                  className="form-control"
                  placeholder={(isBosanmaTuru || isCezaTuru || isIscilikTuru) ? 'Karşı Vekil Bilgileri' : 'Karşı Taraf Sigorta Şirketi Vekili'}
                />
              </div>
            </div>
          </div>

          {/* Arabuluculuk — bütün dosya türlerinde. Belge bağlantıları burada
              değil, dosya detayındaki Arabuluculuk bölümünde. */}
          <div className="form-row-full arb-bolum arb-form-blok">
            <button
              type="button"
              className={'arb-form-baslik' + (arabuluculukAcikMi ? ' acik' : '')}
              onClick={() => setArabuluculukAcik(!arabuluculukAcikMi)}
              aria-expanded={arabuluculukAcikMi}
            >
              <span className="arb-form-baslik-ad">Arabuluculuk</span>
              {!arabuluculukAcikMi && arabuluculukOzeti && <span className="arb-form-ozet">{arabuluculukOzeti}</span>}
              <span className="arb-form-ok" aria-hidden="true">▾</span>
            </button>
            {arabuluculukAcikMi && (
              <div className="arb-form-icerik">
                <div className="form-row">
                  <div className="form-column">
                    <div className="form-group">
                      <span className="field-label-with-pin"><span>Başvuru Tarihi</span>{fieldPin('ArabuluculukTarihi')}</span>
                      <input
                        type="date"
                        name="ArabuluculukTarihi"
                        value={formData.ArabuluculukTarihi || ''}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="form-column">
                    <div className="form-group">
                      <span className="field-label-with-pin"><span>Son Tutanak Tarihi</span>{fieldPin('SonTutanakTarihi')}</span>
                      <input
                        type="date"
                        name="SonTutanakTarihi"
                        value={formData.SonTutanakTarihi || ''}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <span className="field-label-with-pin"><span>Sonuç</span>{fieldPin('ArabuluculukSonucu')}</span>
                  <div className="arb-secim" role="radiogroup" aria-label="Arabuluculuk sonucu">
                    {SONUC_SIRASI.map((s) => {
                      const secili = parseInt(formData.ArabuluculukSonucu, 10) === s;
                      return (
                        <button
                          key={s}
                          type="button"
                          role="radio"
                          aria-checked={secili}
                          className={'arb-secim-dugme arb-ton-' + ARABULUCULUK_SONUC[s].ton + (secili ? ' secili' : '')}
                          onClick={() => arabuluculukSonucuSec(s)}
                        >
                          <span className="arb-secim-isaret" aria-hidden="true" />
                          {ARABULUCULUK_SONUC[s].kisa}
                        </button>
                      );
                    })}
                  </div>
                </div>
                <div className="form-group">
                  <span className="field-label-with-pin"><span>Büro / Dosya No</span>{fieldPin('ArabuluculukDosyaNo')}</span>
                  <input
                    type="text"
                    name="ArabuluculukDosyaNo"
                    value={formData.ArabuluculukDosyaNo || ''}
                    onChange={handleChange}
                    className="form-control"
                    maxLength={300}
                    placeholder="Ör. Ankara Arabuluculuk Bürosu 2026/1234"
                  />
                </div>
                <p className="arb-form-not">
                  Son tutanağı (UYAP UDF'si) Belgeler'e eklediğinizde bu alanlar kendiliğinden dolar.
                </p>
              </div>
            )}
          </div>

          {/* Bağlantılı Dosyalar */}
          <div className="form-row-full" style={{ marginTop: '20px' }}>
            <div className="form-group">
              <label>Bağlantılı Dosyalar</label>

              {aktarimNotu && (
                <p style={{
                  margin: `6px 0 10px`, padding: `8px 10px`, fontSize: 13, lineHeight: 1.45,
                  color: `#2b3652`, background: `rgba(201, 162, 74, 0.12)`,
                  border: `1px solid rgba(201, 162, 74, 0.35)`, borderRadius: 8
                }}>
                  {aktarimNotu}
                </p>
              )}
              
              {/* Arama Input'u */}
              <input
                type="text"
                placeholder="🔍 Föy No veya Müvekkil'e göre ara..."
                value={linkedFilesSearchTerm}
                onChange={(e) => setLinkedFilesSearchTerm(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  marginBottom: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
              />
              
              {/* Seçilen dosyalar (arama filtresinden bağımsız görünür) */}
              {selectedLinkedFiles.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '10px' }}>
                  {selectedLinkedFiles.map((id) => {
                    const f = allCaseFiles.find((x) => (x.Id ?? x.id) === id);
                    const foy = f ? (f.FoyNo ?? f.foyNo ?? id) : id;
                    const muv = f ? (f.Muvekkil ?? f.muvekkil ?? '') : '';
                    return (
                      <span
                        key={id}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '6px',
                          background: '#eef5ff',
                          border: '1px solid #cfe0ff',
                          color: '#1a4fa0',
                          borderRadius: '999px',
                          padding: '4px 10px',
                          fontSize: '13px',
                          fontWeight: 600
                        }}
                      >
                        {foy}{muv ? ` - ${muv}` : ''}
                        <button
                          type="button"
                          onClick={() => toggleLinkedFile(id)}
                          title="Kaldır"
                          style={{
                            border: 'none',
                            background: 'transparent',
                            color: '#1a4fa0',
                            cursor: 'pointer',
                            fontSize: '15px',
                            lineHeight: 1,
                            padding: 0
                          }}
                        >
                          ×
                        </button>
                      </span>
                    );
                  })}
                </div>
              )}

              {/* Seçilebilir dosya listesi (checkbox) */}
              <div
                style={{
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  maxHeight: '240px',
                  overflowY: 'auto',
                  background: '#fff'
                }}
              >
                {loadingCaseFiles ? (
                  <div style={{ padding: '12px', color: '#666', fontSize: '14px' }}>Yükleniyor...</div>
                ) : (
                  (() => {
                    const currentFileId = caseFile ? (caseFile.Id ?? caseFile.id) : null;
                    const searchLower = linkedFilesSearchTerm.toLowerCase().trim();
                    const list = allCaseFiles
                      .filter((file) => {
                        const fileId = file.Id ?? file.id;
                        if (currentFileId != null && fileId === currentFileId) return false;
                        if (searchLower) {
                          const foyNo = String(file.FoyNo ?? file.foyNo ?? '').toLowerCase();
                          const muvekkil = String(file.Muvekkil ?? file.muvekkil ?? '').toLowerCase();
                          return foyNo.includes(searchLower) || muvekkil.includes(searchLower);
                        }
                        return true;
                      })
                      .sort((a, b) => {
                        const foyNoA = String(a.FoyNo ?? a.foyNo ?? '').trim();
                        const foyNoB = String(b.FoyNo ?? b.foyNo ?? '').trim();
                        const numA = parseInt(foyNoA.match(/\d+/)?.[0] || '0');
                        const numB = parseInt(foyNoB.match(/\d+/)?.[0] || '0');
                        if (numA !== numB) return numA - numB;
                        return foyNoA.localeCompare(foyNoB, 'tr', { numeric: true });
                      });

                    if (list.length === 0) {
                      return (
                        <div style={{ padding: '12px', color: '#888', fontSize: '14px' }}>
                          Sonuç bulunamadı
                        </div>
                      );
                    }

                    return list.map((file) => {
                      const fileId = file.Id ?? file.id;
                      const checked = selectedLinkedFiles.includes(fileId);
                      const foyNo = file.FoyNo ?? file.foyNo ?? 'N/A';
                      const muvekkil = file.Muvekkil ?? file.muvekkil ?? 'N/A';
                      return (
                        <label
                          key={fileId}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '8px 12px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #f0f0f0',
                            background: checked ? '#eef5ff' : 'transparent'
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => toggleLinkedFile(fileId)}
                            style={{ width: '16px', height: '16px', flex: '0 0 auto', accentColor: '#1a4fa0' }}
                          />
                          <span style={{ fontSize: '14px', color: '#333' }}>
                            Föy No: {foyNo} - {muvekkil}
                          </span>
                        </label>
                      );
                    });
                  })()
                )}
              </div>
              <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                Eklemek/çıkarmak için kutucuklara tıklayın. Arama yapmanız seçili dosyaları etkilemez.
                {selectedLinkedFiles.length > 0 && (
                  <span style={{ marginLeft: '10px', color: '#0066cc', fontWeight: 'bold' }}>
                    {selectedLinkedFiles.length} dosya seçildi
                  </span>
                )}
              </small>
            </div>
          </div>

          {/* Masraf ve Dosya Yükleme Bölümü - Sadece yeni dosya oluştururken */}
          {!caseFile && (
            <>
              {/* Masraf Bölümü - Form dışında */}
              <div className="form-row-full" style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #e0e0e0' }}>
                <div className="form-group">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <h3 style={{ margin: 0 }}>Masraf Bilgileri</h3>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (showMasrafForm) {
                          // Formu kapat
                          setShowMasrafForm(false);
                        } else {
                          // Yeni masraf eklemek için formu aç (önceki masrafları koru)
                          setShowMasrafForm(true);
                        }
                      }}
                      className="btn btn-secondary btn-sm"
                    >
                      {showMasrafForm ? 'Masraf Formunu Kapat' : 'Masraf Ekle'}
                    </button>
                  </div>
                  
                  {/* Eklenen Masraf Bilgileri */}
                  {masrafData && Array.isArray(masrafData) && masrafData.length > 0 && (
                    <div style={{ marginTop: '15px', marginBottom: '15px' }}>
                      <h4 style={{ margin: '0 0 10px 0', color: '#0066cc', fontSize: '16px' }}>Eklenen Masraflar ({masrafData.length})</h4>
                      {masrafData.map((masraf, index) => (
                        <div key={index} style={{ 
                          padding: '15px', 
                          backgroundColor: '#f0f7ff', 
                          border: '1px solid #b3d9ff', 
                          borderRadius: '5px', 
                          marginBottom: '10px'
                        }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                            <h5 style={{ margin: 0, color: '#0066cc', fontSize: '14px' }}>Masraf {index + 1}</h5>
                            <button
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setMasrafData(prev => prev.filter((_, i) => i !== index));
                                setHasChanges(true);
                              }}
                              className="btn btn-danger btn-sm"
                              style={{ padding: '4px 8px', fontSize: '12px' }}
                            >
                              Kaldır
                            </button>
                          </div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', fontSize: '14px' }}>
                            <div>
                              <strong>Masraf Türü:</strong> {masraf.MasrafTuru || masraf.masrafTuru || '-'}
                            </div>
                            <div>
                              <strong>Tutar:</strong> {masraf.Tutar || masraf.tutar ? `${parseFloat(masraf.Tutar || masraf.tutar).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺` : '-'}
                            </div>
                            <div>
                              <strong>Masraf İstenme Tarihi:</strong> {masraf.MasrafIstenmeTarihi || masraf.masrafIstenmeTarihi ? new Date(masraf.MasrafIstenmeTarihi || masraf.masrafIstenmeTarihi).toLocaleDateString('tr-TR') : '-'}
                            </div>
                            <div>
                              <strong>Son Tarih:</strong> {masraf.SonTarih || masraf.sonTarih ? new Date(masraf.SonTarih || masraf.sonTarih).toLocaleDateString('tr-TR') : '-'}
                            </div>
                            {(masraf.Aciklama || masraf.aciklama) && (
                              <div style={{ gridColumn: '1 / -1' }}>
                                <strong>Açıklama:</strong> {masraf.Aciklama || masraf.aciklama}
                              </div>
                            )}
                            <div>
                              <strong>Gelir/Gider:</strong> {(masraf.IsGelir ?? masraf.isGelir) ? 'Gelir' : 'Gider'}
                            </div>
                            {(masraf.IsBerileVerilen ?? masraf.isBerileVerilen) && (
                              <div>
                                <strong>Berile Verilen:</strong> Evet
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Not Bölümü - Form dışında */}
              <div className="form-row-full" style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #e0e0e0' }}>
                <div className="form-group">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <h3 style={{ margin: 0 }}>Not Bilgileri</h3>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowNoteForm(!showNoteForm);
                      }}
                      className="btn btn-secondary btn-sm"
                    >
                      {showNoteForm ? 'Not Formunu Kapat' : 'Not Ekle'}
                    </button>
                  </div>
                  
                  {/* Eklenen Not Bilgileri */}
                  {noteData && Array.isArray(noteData) && noteData.length > 0 && (
                    <div style={{ marginTop: '15px', marginBottom: '15px' }}>
                      <h4 style={{ margin: '0 0 10px 0', color: '#0066cc', fontSize: '16px' }}>Eklenen Notlar ({noteData.length})</h4>
                      {noteData.map((note, index) => (
                        <div 
                          key={index}
                          style={{ 
                            padding: '15px', 
                            backgroundColor: '#f0f7ff', 
                            border: '1px solid #b3d9ff', 
                            borderRadius: '5px', 
                            marginBottom: '10px'
                          }}
                        >
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                            <h5 style={{ margin: 0, color: '#0066cc', fontSize: '14px' }}>Not {index + 1}</h5>
                            <button
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setNoteData(prev => prev.filter((_, i) => i !== index));
                                setHasChanges(true);
                              }}
                              className="btn btn-danger btn-sm"
                              style={{ padding: '4px 8px', fontSize: '12px' }}
                            >
                              Kaldır
                            </button>
                          </div>
                          <div style={{ fontSize: '14px' }}>
                            <div style={{ marginBottom: '10px' }}>
                              <strong>Başlık:</strong> {note.Title || note.title || '-'}
                            </div>
                            {(note.Content || note.content) && (
                              <div>
                                <strong>İçerik:</strong> {note.Content || note.content}
                              </div>
                            )}
                            {(note.NoteDate || note.noteDate) && (
                              <div style={{ marginTop: '10px', color: '#666' }}>
                                <strong>Tarih:</strong> {new Date(note.NoteDate || note.noteDate).toLocaleDateString('tr-TR')}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Dosya Yükleme Bölümü */}
              <div className="form-row-full" style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #e0e0e0' }}>
                <div className="form-group">
                  <h3 style={{ marginBottom: '15px' }}>Belge Yükleme</h3>
                  
                  {/* Belge Türü Seçimi */}
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '10px', fontWeight: '600' }}>Belge Türü</label>
                    <select
                      value={selectedDocumentType}
                      onChange={(e) => {
                        const newType = parseInt(e.target.value);
                        setSelectedDocumentType(newType);
                      }}
                      className="form-control"
                    >
                      <option value={DOCUMENT_TYPE.Other}>{DOCUMENT_TYPE_LABELS[DOCUMENT_TYPE.Other]}</option>
                      <option value={DOCUMENT_TYPE.Vekaletname}>{DOCUMENT_TYPE_LABELS[DOCUMENT_TYPE.Vekaletname]}</option>
                      <option value={DOCUMENT_TYPE.KazaTespitTutanagi}>{DOCUMENT_TYPE_LABELS[DOCUMENT_TYPE.KazaTespitTutanagi]}</option>
                      <option value={DOCUMENT_TYPE.IbranameMuvafakatname}>{DOCUMENT_TYPE_LABELS[DOCUMENT_TYPE.IbranameMuvafakatname]}</option>
                    </select>
                  </div>

                  {/* Dosya Yükleme Alanı */}
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '10px', fontWeight: '600' }}>
                      {DOCUMENT_TYPE_LABELS[selectedDocumentType]}
                    </label>
                    
                    {/* Drag & Drop Alanı */}
                    <div
                      className={`drag-drop-area ${dragActive ? 'drag-active' : ''}`}
                      onDragEnter={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDragActive(true);
                      }}
                      onDragLeave={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDragActive(false);
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDragActive(false);
                        
                        const files = e.dataTransfer.files;
                        if (files && files.length > 0) {
                          processSelectedFiles(selectedDocumentType, files);
                        }
                      }}
                      style={{
                        border: '2px dashed #ccc',
                        borderRadius: '6px',
                        padding: '40px',
                        textAlign: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.3s',
                        backgroundColor: dragActive ? '#e8f4f8' : '#f9f9f9',
                        borderColor: dragActive ? '#667eea' : '#ccc'
                      }}
                      onClick={() => {
                        const input = document.createElement('input');
                        input.type = 'file';
                        input.multiple = true;
                        input.accept = '.pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx';
                        input.onchange = (e) => {
                          const files = e.target.files;
                          if (files && files.length > 0) {
                            processSelectedFiles(selectedDocumentType, files);
                          }
                        };
                        input.click();
                      }}
                    >
                      {selectedFiles[selectedDocumentType] ? (
                        <div>
                          {Array.isArray(selectedFiles[selectedDocumentType]) ? (
                            <div>
                              <p style={{ margin: 0, color: '#28a745', fontWeight: '600' }}>
                                ✓ {selectedFiles[selectedDocumentType].length} dosya seçildi
                              </p>
                              <div style={{ marginTop: '10px', textAlign: 'left', maxHeight: '200px', overflowY: 'auto' }}>
                                {selectedFiles[selectedDocumentType].map((file, index) => (
                                  <div key={index} style={{ marginBottom: '8px', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f9f9f9' }}>
                                    <p style={{ fontSize: '12px', color: '#666', marginBottom: '5px', fontWeight: 'bold' }}>
                                      {index + 1}. {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
                                    </p>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <div>
                              <p style={{ margin: 0, color: '#28a745', fontWeight: '600' }}>
                                ✓ {selectedFiles[selectedDocumentType].name}
                              </p>
                              <p style={{ margin: '5px 0 0 0', fontSize: '12px', color: '#666' }}>
                                {(selectedFiles[selectedDocumentType].size / 1024 / 1024).toFixed(2)} MB
                              </p>
                            </div>
                          )}
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedFiles(prev => {
                                const newFiles = { ...prev };
                                delete newFiles[selectedDocumentType];
                                return newFiles;
                              });
                              setFileDescriptions(prev => {
                                const newDescs = { ...prev };
                                delete newDescs[selectedDocumentType];
                                return newDescs;
                              });
                              setHasChanges(true);
                            }}
                            style={{
                              marginTop: '10px',
                              padding: '5px 15px',
                              background: '#dc3545',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer'
                            }}
                          >
                            Dosyaları Kaldır
                          </button>
                        </div>
                      ) : (
                        <div>
                          <p style={{ margin: 0, color: '#666' }}>
                            📁 Dosyaları buraya sürükleyip bırakın veya tıklayarak seçin
                          </p>
                          <p style={{ margin: '5px 0 0 0', fontSize: '12px', color: '#999' }}>
                            Çoklu dosya seçimi desteklenir
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Seçili Dosyalar ve Açıklamalar */}
                    {selectedFiles[selectedDocumentType] && (
                      <div style={{ marginTop: '15px' }}>
                        {Array.isArray(selectedFiles[selectedDocumentType]) ? (
                          selectedFiles[selectedDocumentType].map((file, index) => (
                            <div key={index} style={{ marginBottom: '15px', padding: '12px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff' }}>
                              <p style={{ fontSize: '13px', color: '#333', marginBottom: '8px', fontWeight: 'bold' }}>
                                {index + 1}. {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
                              </p>
                              <textarea
                                value={(fileDescriptions[selectedDocumentType] && typeof fileDescriptions[selectedDocumentType] === 'object' && !Array.isArray(fileDescriptions[selectedDocumentType])) 
                                  ? (fileDescriptions[selectedDocumentType][index] || '') 
                                  : (index === 0 ? (fileDescriptions[selectedDocumentType] || '') : '')}
                                onChange={(e) => {
                                  setFileDescriptions(prev => {
                                    const current = prev[selectedDocumentType] || {};
                                    const newDescs = typeof current === 'object' && !Array.isArray(current) 
                                      ? { ...current } 
                                      : (index === 0 ? { 0: current || '' } : {});
                                    newDescs[index] = e.target.value;
                                    return { ...prev, [selectedDocumentType]: newDescs };
                                  });
                                  setHasChanges(true);
                                }}
                                rows="2"
                                placeholder={`${file.name} için açıklama (opsiyonel)...`}
                                className="form-control"
                                style={{ fontSize: '12px' }}
                              />
                            </div>
                          ))
                        ) : (
                          <div style={{ marginTop: '10px' }}>
                            <textarea
                              value={(fileDescriptions[selectedDocumentType] && typeof fileDescriptions[selectedDocumentType] === 'object' && !Array.isArray(fileDescriptions[selectedDocumentType])) 
                                ? (fileDescriptions[selectedDocumentType][0] || '') 
                                : (typeof fileDescriptions[selectedDocumentType] === 'string' ? fileDescriptions[selectedDocumentType] : '')}
                              onChange={(e) => {
                                setFileDescriptions(prev => {
                                  const current = prev[selectedDocumentType];
                                  if (typeof current === 'object' && !Array.isArray(current)) {
                                    return { ...prev, [selectedDocumentType]: { ...current, 0: e.target.value } };
                                  }
                                  return { ...prev, [selectedDocumentType]: e.target.value };
                                });
                                setHasChanges(true);
                              }}
                              rows="2"
                              placeholder="Dosya hakkında açıklama (opsiyonel)..."
                              className="form-control"
                              style={{ fontSize: '12px' }}
                            />
                          </div>
                        )}
                      </div>
                    )}
                    
                    {uploading[selectedDocumentType] && (
                      <p style={{ marginTop: '5px', color: '#666', fontSize: '12px' }}>Yükleniyor...</p>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="form-actions">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {caseFile && onArchiveRequest && (
                  <button 
                    type="button" 
                    onClick={onArchiveRequest} 
                    className="btn btn-warning"
                    disabled={loading}
                    style={{ marginRight: '10px' }}
                  >
                    Arşiv Gönderme İsteği
                  </button>
                )}
                {caseFile && onDelete && (
                  <button 
                    type="button" 
                    onClick={onDelete} 
                    className="btn btn-danger"
                    disabled={loading}
                    style={{ marginRight: '10px' }}
                  >
                    Dosyayı Sil
                  </button>
                )}
              </div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button type="button" onClick={onCancel} className="btn btn-secondary">
                  İptal
                </button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Kaydediliyor...' : (caseFile ? 'Güncelle' : 'Kaydet')}
                </button>
              </div>
            </div>
          </div>
        </form>
        
        {/* Masraf Form - Form dışında render ediliyor (nested form sorununu önlemek için) */}
        {/* MasrafForm kendi penceresini en ust katmanda acar (createPortal);
            burada yer kaplayan bir sarmalayiciya gerek yok. */}
        {!caseFile && showMasrafForm && (
          <>
            <MasrafForm
              masraf={null}
              caseFileId={null}
              caseFiles={EMPTY_CASE_FILES}
              hideCaseFileSelection={true}
              onSubmit={(masrafFormData) => {
                // State güncellemelerini hemen yap
                setIsMasrafSubmitting(true);
                // Yeni masrafı array'e ekle (öncekileri koru)
                setMasrafData(prev => [...(prev || []), masrafFormData]);
                setShowMasrafForm(false);
                setHasChanges(true);
                // Masraf submit işlemi tamamlandıktan sonra flag'i temizle
                setTimeout(() => {
                  setIsMasrafSubmitting(false);
                }, 100);
              }}
              onCancel={() => setShowMasrafForm(false)}
            />
          </>
        )}

        {/* Note Form - Form dışında render ediliyor (nested form sorununu önlemek için) */}
        {!caseFile && showNoteForm && (
          <>
            <NoteForm
              note={null}
              caseFileId={null}
              onSubmit={(noteFormData) => {
                // State güncellemelerini hemen yap
                setIsNoteSubmitting(true);
                // Yeni notu array'e ekle (öncekileri koru)
                setNoteData(prev => [...(prev || []), noteFormData]);
                setShowNoteForm(false);
                setHasChanges(true);
                // Note submit işlemi tamamlandıktan sonra flag'i temizle
                setTimeout(() => {
                  setIsNoteSubmitting(false);
                }, 100);
              }}
              onCancel={() => setShowNoteForm(false)}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default CaseFileForm;
